import { mapGetters } from 'vuex';

export default {
  data: () => ({
    i18n_mode: process.env.VUE_APP_LANG_MODE,
    i18n_message: {
        '発送するカード': {
          'en': 'card to send',
          'ko': '발송할 카드',
          'zh': '待寄送的賀卡',
          'zh-TW': '待寄送的贺卡',
        },
        '登録情報': {
          'en': 'Registration information',
          'ko': '등록정보',
          'zh': '註冊資訊',
          'zh-TW': '注册信息',
        },
        '個人情報': {
          'en': 'personal information',
          'ko': '개인정보',
          'zh': '個人資訊',
          'zh-TW': '个人信息',
        },
        'パスワード変更': {
          'en': 'Change password',
          'ko': '비밀번호 변경',
          'zh': '更改密碼',
          'zh-TW': '更改密码',
        },
        '戻る': {
          'en': 'return',
          'ko': '뒤로',
          'zh': '返回',
          'zh-TW': '返回',
        },
        '最終確認': {
          'en': 'Final confirmation',
          'ko': '최종 확인',
          'zh': '最終確認',
          'zh-TW': '最终确认',
        },
        '選択したものでお間違いないでしょうか？': {
          'en': 'Are you sure about the ',
          'ko': '당신이 선택한 것에 ',
          'zh': '你確定你選擇的',
          'zh-TW': '你确定你选择的',
        },
        '(※確定後の変更はできません)': {
          'en': 'one you chose?',
          'ko': '틀림없습니까?',
          'zh': '那個嗎？',
          'zh-TW': '那个吗？',
        },
        'キャンセル': {
          'en': 'cancel',
          'ko': '취소',
          'zh': '取消',
          'zh-TW': '取消',
        },
        'はい': {
          'en': 'yes',
          'ko': '예',
          'zh': '是的',
          'zh-TW': '是的',
        },
        '同じガチャを買う': {
          'en': 'buy the same gacha',
          'ko': '같은 가챠를 사',
          'zh': '購買同一款扭蛋',
          'zh-TW': '购买同一款扭蛋',
        },
        'Xmarketリストへ': {
          'en': 'Go to my Xmarket list',
          'ko': '내 Xmarket 목록에',
          'zh': '前往我的 Xmarket 名單',
          'zh-TW': '前往我的 Xmarket 列表',
        },
        'TOPページへ': {
          'en': 'Go to TOP page',
          'ko': 'TOP 페이지로',
          'zh': '回到頂部',
          'zh-TW': '返回顶部',
        },
        '会員登録完了': {
          'en': 'Membership registration completed',
          'ko': '회원 등록 완료',
          'zh': '會員註冊完成',
          'zh-TW': '会员注册完成',
        },
        '会員登録ありがとうございます！': {
          'en': 'Thank you for registering as a member!',
          'ko': '회원 등록 감사합니다!',
          'zh': '感謝您註冊成為會員！',
          'zh-TW': '感谢您注册成为会员！',
        },
        '引き続きガチャの購入をお楽しみください': {
          'en': 'Please continue to enjoy purchasing gacha.',
          'ko': '계속 가챠 구매를 즐기세요',
          'zh': '請繼續享受扭蛋購物的樂趣。',
          'zh-TW': '请继续享受扭蛋购物的乐趣。',
        },
        '確認': {
          'en': 'confirmation',
          'ko': '확인',
          'zh': '確認',
          'zh-TW': '确认',
        },
        '友達紹介コードの登録が完了しました': {
          'en': 'Your friend referral code has been registered',
          'ko': '친구 소개 코드 등록이 완료되었습니다.',
          'zh': '您的好友推薦碼已註冊',
          'zh-TW': '您的好友推荐码已注册',
        },
        '友達紹介コードを入力してください': {
          'en': 'Enter your friend referral code',
          'ko': '친구 추천 코드를 입력하세요.',
          'zh': '輸入您的好友推薦碼',
          'zh-TW': '输入您的好友推荐码',
        },
        '購入内容確認': {
          'en': 'Confirm purchase details',
          'ko': '구매 내용 확인',
          'zh': '購買確認',
          'zh-TW': '购买确认',
        },
        '購入商品名': {
          'en': 'Purchased product name',
          'ko': '구매상품명',
          'zh': '購買的產品名稱',
          'zh-TW': '购买的产品名称',
        },
        '消費コイン': {
          'en': 'Coins consumed',
          'ko': '소비 동전',
          'zh': '消耗的硬幣',
          'zh-TW': '消耗的硬币',
        },
        'を消費し': {
          'en': 'consume',
          'ko': '소비',
          'zh': '消耗',
          'zh-TW': '消耗',
        },
        '回ガチャを引く': {
          'en': 'Pull the gacha',
          'ko': '한 번 뽑기를 당기다',
          'zh': '抽扭蛋',
          'zh-TW': '抽扭蛋',
        },
        '所持コイン': {
          'en': 'Coins owned',
          'ko': '소지 코인',
          'zh': '擁有的硬幣',
          'zh-TW': '拥有的硬币',
        },
        'よろしいですか？': {
          'en': 'Are you sure?',
          'ko': '괜찮습니까?',
          'zh': '這樣可以嗎？',
          'zh-TW': '这样可以吗？',
        },
        '商品ページに戻る': {
          'en': 'Return to product page',
          'ko': '상품 페이지로 돌아가기',
          'zh': '返回產品頁面',
          'zh-TW': '返回产品页面',
        },
        'いいえ': {
          'en': 'no',
          'ko': '아니오',
          'zh': '不',
          'zh-TW': '不',
        },
        'コインが不足しています': {
          'en': 'running out of coins',
          'ko': '동전 부족',
          'zh': '硬幣不夠',
          'zh-TW': '硬币不够',
        },
        'コイン購入': {
          'en': 'Purchase coins',
          'ko': '동전 구매',
          'zh': '購買金幣',
          'zh-TW': '购买金币',
        },
        '購入コイン': {
          'en': 'Purchase coins',
          'ko': '구매 코인',
          'zh': '購買金幣',
          'zh-TW': '购买金币',
        },
        'お支払い金額': {
          'en': 'Payment amount',
          'ko': '지불 금액',
          'zh': '付款金額',
          'zh-TW': '付款金额',
        },
        '購入する': {
          'en': 'buy',
          'ko': '구매',
          'zh': '立即購買',
          'zh-TW': '立即购买',
        },
        '決済が成功し、コインが反映しました。': {
          'en': 'The payment was successful and the coins were credited.',
          'ko': '결제가 성공하고 동전이 반영했습니다.',
          'zh': '付款成功，款項已到帳。',
          'zh-TW': '付款成功，款项已到账。',
        },
        '決済が失敗しました。クレジットカードの状態をご確認ください。\n状態が不明な場合は、クレジットカード会社にお問い合わせください。': {
          'en': 'Payment failed. Please check the status of your credit card. \nIf you are unsure of the status, please contact your credit card company.',
          'ko': '결제가 실패했습니다. 신용 카드 상태를 확인하십시오. \n 상태가 알려지지 않은 경우 신용 카드 회사에 문의하십시오.',
          'zh': '付款失敗。請查詢您的信用卡狀態。如有疑問，請聯絡您的信用卡公司。',
          'zh-TW': '付款失败。请查询您的信用卡状态。如有疑问，请联系您的信用卡公司。',
        },
        'ご入力いただいたカード情報が確認できませんでした。\n再度ご入力内容をご確認ください。': {
          'en': 'The card information you entered could not be confirmed. \nPlease check the information you entered again.',
          'ko': '입력하신 카드 정보를 확인할 수 없습니다.\n다시 입력 내용을 확인해 주십시오.',
          'zh': '您輸入的銀行卡資訊無法驗證。 \n請再次檢查您輸入的資訊。',
          'zh-TW': '您输入的银行卡信息无法验证。\n请再次核对您输入的信息。',
        },
        'カード番号': {
          'en': 'card number',
          'ko': '카드 번호',
          'zh': '卡號',
          'zh-TW': '卡号',
        },
        'カード(年月)': {
          'en': 'Card (year/month)',
          'ko': '카드(year/month)',
          'zh': '卡(year/month)',
          'zh-TW': '卡(year/month)',
        },
        'カード(セキュリティコード)': {
          'en': 'Card (security code)',
          'ko': '카드 (보안 코드)',
          'zh': '卡（安全碼）',
          'zh-TW': '卡（安全码）',
        },
        'カード名義': {
          'en': 'Card holder name',
          'ko': '카드 명의',
          'zh': '持卡人姓名',
          'zh-TW': '持卡人姓名',
        },
        'システムメンテナンス': {
          'en': 'system maintenance',
          'ko': '시스템 유지보수',
          'zh': '系統維​​護',
          'zh-TW': '系统维护',
        },
        '通信エラー': {
          'en': 'Communication error',
          'ko': '통신 오류',
          'zh': '通訊錯誤',
          'zh-TW': '通信错误',
        },
        'その他': {
          'en': 'others',
          'ko': '기타',
          'zh': '其他的',
          'zh-TW': '其他的',
        },
        'が不正です': {
          'en': 'is incorrect',
          'ko': '불법입니다.',
          'zh': '無效',
          'zh-TW': '无效',
        },
        '仮パスワード発行': {
          'en': 'Temporary password issued',
          'ko': '임시 비밀번호 발급',
          'zh': '已發布臨時密碼',
          'zh-TW': '已发布临时密码',
        },
        '登録されたメールアドレスに仮パスワードを送信します。': {
          'en': 'A temporary password will be sent to the registered email address.',
          'ko': '등록된 이메일 주소에 임시 비밀번호를 보냅니다.',
          'zh': '系統會將臨時密碼傳送到註冊郵箱。',
          'zh-TW': '系统会将临时密码发送到注册邮箱。',
        },
        'メール送信': {
          'en': 'Send email',
          'ko': '메일 보내기',
          'zh': '傳送電子郵件',
          'zh-TW': '发送电子邮件',
        },
        '購入日': {
          'en': 'Purchase date',
          'ko': '구매일',
          'zh': '購買日期',
          'zh-TW': '购买日期',
        },
        '履歴': {
          'en': 'History',
          'ko': '히스토리',
          'zh': '歷史',
          'zh-TW': '历史',
        },
        '日付': {
          'en': 'date',
          'ko': '날짜',
          'zh': '日期',
          'zh-TW': '日期',
        },
        '商品名': {
          'en': 'Product name',
          'ko': '상품명',
          'zh': '產品名稱',
          'zh-TW': '产品名称',
        },
        '発送状況': {
          'en': 'Shipping status',
          'ko': '배송 상황',
          'zh': '出貨狀態',
          'zh-TW': '发货状态',
        },
        'コイン購入完了': {
          'en': 'Coin purchase completed',
          'ko': '코인 구매 완료',
          'zh': '硬幣購買完成',
          'zh-TW': '硬币购买完成',
        },
        '購入失敗': {
          'en': 'Purchase failure',
          'ko': '구매 실패',
          'zh': '購買失敗',
          'zh-TW': '购买失败',
        },
        'コインのご購入ありがとうございました。': {
          'en': 'Thank you for purchasing coins.',
          'ko': '동전을 구입해 주셔서 감사합니다.',
          'zh': '感謝您購買紀念幣。',
          'zh-TW': '感谢您购买纪念币。',
        },
        '引き続きDORIMAをお楽しみください。': {
          'en': 'Please continue to enjoy DORIMA.',
          'ko': '계속 DORIMA를 즐길 수 있습니다.',
          'zh': '請繼續享受《多麗瑪》帶來的樂趣。',
          'zh-TW': '请继续享受《多丽玛》带来的乐趣。',
        },
        '決済に失敗しました。': {
          'en': 'Payment failed.',
          'ko': '결제에 실패했습니다.',
          'zh': '付款失敗。',
          'zh-TW': '付款失败。',
        },
        '他の決済方法をご利用ください。': {
          'en': 'Please use another payment method.',
          'ko': '다른 결제 방법을 이용하십시오.',
          'zh': '請使用其他付款方式。',
          'zh-TW': '请使用其他付款方式。',
        },
        'HOMEへ戻る': {
          'en': 'Return to HOME',
          'ko': 'HOME으로 돌아가기',
          'zh': '回首頁',
          'zh-TW': '返回首页',
        },
        '名前': {
          'en': 'name',
          'ko': '이름',
          'zh': '姓名',
          'zh-TW': '姓名',
        },
        '国': {
          'en': 'country',
          'ko': '국가',
          'zh': '國家',
          'zh-TW': '国家',
        },
        '郵便番号': {
          'en': 'post code',
          'ko': '우편번호',
          'zh': '郵遞區號',
          'zh-TW': '邮政编码',
        },
        '都道府県': {
          'en': 'state',
          'ko': '특별시・광역시・도・특별자치도',
          'zh': '直轄市・県・市（省轄市）',
          'zh-TW': '省・直辖市・自治区・特别行政区',
        },
        '市区町村': {
          'en': 'City / Town / Municipality',
          'ko': '시・군・구',
          'zh': '區・鎮・鄉・市',
          'zh-TW': '区・縣（县）・県級市・郷（乡）・鎮',
        },
        '番地': {
          'en': 'street address',
          'ko': '번지',
          'zh': '街道地址',
          'zh-TW': '街道地址',
        },
        '建物名': {
          'en': 'Building name',
          'ko': '건물명',
          'zh': '建築物名稱',
          'zh-TW': '建筑物名称',
        },
        '電話番号': {
          'en': 'telephone number',
          'ko': '전화번호',
          'zh': '電話號碼',
          'zh-TW': '电话号码',
        },
        'SMS認証': {
          'en': 'SMS authentication',
          'ko': 'SMS 인증',
          'zh': '簡訊認證',
          'zh-TW': '短信认证',
        },
        'メールアドレス': {
          'en': 'email address',
          'ko': '이메일 주소',
          'zh': '電子郵件',
          'zh-TW': '电子邮件',
        },
        '友達紹介コード': {
          'en': 'Friend Referral Code',
          'ko': '친구 소개 코드',
          'zh': '好友推薦碼',
          'zh-TW': '好友推荐码',
        },
        '個人情報を変更するには、お問い合わせください。': {
          'en': 'To change your personal information, please contact us.',
          'ko': '개인정보를 변경하려면 문의하시기 바랍니다.',
          'zh': '如需更改您的個人訊息，請聯絡我們。',
          'zh-TW': '如需更改您的个人信息，请联系我们。',
        },
        '初めて配送を選択する際に、この情報を入力できます。': {
          'en': 'You can enter this information the first time you select shipping.',
          'ko': '처음 배송을 선택할 때 이 정보를 입력할 수 있습니다.',
          'zh': '您可以在首次選擇配送方式時輸入此資訊。',
          'zh-TW': '您可以在首次选择配送方式时输入此信息。',
        },
        'お問い合わせ': {
          'en': 'inquiry',
          'ko': '문의',
          'zh': '詢問',
          'zh-TW': '询问',
        },
        '変更が完了しました': {
          'en': 'Changes completed',
          'ko': '변경이 완료되었습니다.',
          'zh': '變更已完成',
          'zh-TW': '变更已完成',
        },
        'SMSコードを送信しますか？': {
          'en': 'Would you like to send an SMS code?',
          'ko': 'SMS 코드를 보내시겠습니까?',
          'zh': '發送簡訊驗證碼？',
          'zh-TW': '发送短信验证码？',
        },
        'お知らせ': {
          'en': 'Notice',
          'ko': '공지',
          'zh': '注意',
          'zh-TW': '注意',
        },
        '大切なお知らせ': {
          'en': 'Important notice',
          'ko': '소중한 소식',
          'zh': '重要通知',
          'zh-TW': '重要通知',
        },
        '確認コードを入力': {
          'en': 'Enter verification code',
          'ko': '확인 코드 입력',
          'zh': '請輸入驗證碼',
          'zh-TW': '请输入验证码',
        },
        'メールで送信された確認コードを入力してください。': {
          'en': 'Please enter the verification code sent to you via email.',
          'ko': '이메일로 전송된 인증 코드를 입력하세요.',
          'zh': '請輸入我們透過電子郵件發送給您的驗證碼。',
          'zh-TW': '请输入我们通过电子邮件发送给您的验证码。',
        },
        '動画を見てコインを獲得': {
          'en': 'Watch videos and get coins',
          'ko': '동영상을 보고 Coin을 Get',
          'zh': '觀看影片即可賺取金幣',
          'zh-TW': '观看视频即可赚取金币',
        },
        '視聴済み': {
          'en': 'Already watched',
          'ko': '시청됨',
          'zh': '已觀看',
          'zh-TW': '已观看',
        },
        '引換履歴&コイン履歴': {
          'en': 'Exchange history & coin history',
          'ko': '교환 이력 & 코인 이력',
          'zh': '兌換歷史和硬幣歷史',
          'zh-TW': '兑换历史和硬币历史',
        },
        '取引日': {
          'en': 'trading date',
          'ko': '거래일',
          'zh': '交易日期',
          'zh-TW': '交易日期',
        },
        '取引内容': {
          'en': 'Transaction details',
          'ko': '거래 내용',
          'zh': '交易詳情',
          'zh-TW': '交易详情',
        },
        '引換・付与コイン': {
          'en': 'Exchange/grant coins',
          'ko': '교환·부여 코인',
          'zh': '兌換/授予代幣',
          'zh-TW': '兑换/授予代币',
        },
        '引換履歴&コイン履歴がありません。': {
          'en': 'There is no exchange history or coin history.',
          'ko': '교환 이력 & 코인 이력이 없습니다.',
          'zh': '沒有兌換記錄或硬幣交易記錄。',
          'zh-TW': '没有兑换记录或硬币交易记录。',
        },
        '円': {
          'en': 'yen',
          'ko': 'yen',
          'zh': '圓圈',
          'zh-TW': '圆圈',
        },
        '仮パスワード送信完了': {
          'en': 'Temporary password sent successfully',
          'ko': '임시 비밀번호 전송 완료',
          'zh': '已發送臨時密碼',
          'zh-TW': '已发送临时密码',
        },
        '登録されたメールアドレスに仮パスワードを送信しました。': {
          'en': 'A temporary password has been sent to your registered email address.',
          'ko': '등록된 이메일 주소에 임시 비밀번호를 보냈습니다.',
          'zh': '臨時密碼已寄至您的註冊信箱。',
          'zh-TW': '临时密码已发送至您的注册邮箱。',
        },
        'メールを確認してください。': {
          'en': 'Please check your email.',
          'ko': '이메일을 확인하십시오.',
          'zh': '請查收您的電子郵件。',
          'zh-TW': '请查收您的电子邮件。',
        },
        'ログイン': {
          'en': 'Login',
          'ko': '로그인',
          'zh': '登入',
          'zh-TW': '登录',
        },
        '日時': {
          'en': 'date and time',
          'ko': '일시',
          'zh': '日期和時間',
          'zh-TW': '日期和时间',
        },
        'コイン数': {
          'en': 'number of coins',
          'ko': '동전 수',
          'zh': '硬幣數量',
          'zh-TW': '硬币数量',
        },
        'お支払額': {
          'en': 'Payment amount',
          'ko': '지불액',
          'zh': '付款金額',
          'zh-TW': '付款金额',
        },
        '備考': {
          'en': 'remarks',
          'ko': '비고',
          'zh': '評論',
          'zh-TW': '评论',
        },
        '次へ': {
          'en': 'to the next',
          'ko': '다음',
          'zh': '到下一個',
          'zh-TW': '到下一个',
        },
        '配送コード': {
          'en': 'shipping code',
          'ko': '배송 코드',
          'zh': '運費代碼',
          'zh-TW': '运费代码',
        },
        '一覧に戻る': {
          'en': 'Return to list',
          'ko': '목록으로 돌아가기',
          'zh': '返回列表',
          'zh-TW': '返回列表',
        },
        'ラインナップ': {
          'en': 'Product lineup',
          'ko': '상품 라인업',
          'zh': '產品陣容',
          'zh-TW': '产品阵容',
        },
        '販売開始まで': {
          'en': 'Until sales begin',
          'ko': '판매 개시까지',
          'zh': '直到銷售開始',
          'zh-TW': '直到销售开始',
        },
        '新しいパスワード': {
          'en': 'New Password',
          'ko': '새로운 비밀번호',
          'zh': '新密碼',
          'zh-TW': '新密码',
        },
        '半角英数字15文字以内': {
          'en': 'Up to 15 half-width alphanumeric characters',
          'ko': '반각 영숫자 15자 이내',
          'zh': '最多 15 個字母數字字符',
          'zh-TW': '最多 15 个字母数字字符',
        },
        '新しいパスワード確認用': {
          'en': 'To confirm new password',
          'ko': '새로운 비밀번호 확인용',
          'zh': '新密碼確認',
          'zh-TW': '新密码确认',
        },
        '変更する': {
          'en': 'change',
          'ko': '변경하다',
          'zh': '改變',
          'zh-TW': '改变',
        },
        '発送': {
          'en': 'shipping',
          'ko': '발송',
          'zh': '船運',
          'zh-TW': '船运',
        },
        '発送のみ': {
          'en': 'Shipping only',
          'ko': '배송만',
          'zh': '僅限配送',
          'zh-TW': '仅限配送',
        },
        'コインのみ': {
          'en': 'Coin only',
          'ko': '코인 전용',
          'zh': '僅限硬幣',
          'zh-TW': '仅限硬币',
        },
        'Xmarketへ出品': {
          'en': 'Sell ​​on Xmarket',
          'ko': 'Xmarket에 출품',
          'zh': '在 Xmarket 上出售',
          'zh-TW': '在 Xmarket 上出售',
        },
        '登録': {
          'en': 'Registration',
          'ko': '등록',
          'zh': '登記',
          'zh-TW': '登记',
        },
        'コインへの還元数': {
          'en': 'Number of coins redeemed',
          'ko': '동전으로의 환원수',
          'zh': '兌換的硬幣數量',
          'zh-TW': '兑换的硬币数量',
        },
        '発送数': {
          'en': 'Number of selected shipments',
          'ko': '발송을 선택한 수',
          'zh': '出貨次數',
          'zh-TW': '发货次数',
        },
        'Xmarketへ出品数': {
          'en': 'Number of items listed on Xmarket',
          'ko': 'Xmarket에 출품수',
          'zh': 'Xmarket 上列出的商品數量',
          'zh-TW': 'Xmarket 上列出的商品数量',
        },
        '1タップで「発送依頼」、2タップで「Xmarketへ出品」となります。': {
          'en': 'One tap will "request shipping" and two taps will "list on Xmarket."',
          'ko': '1 탭으로 「발송 의뢰」, 2 탭으로 「Xmarket에 출품」이 됩니다.',
          'zh': '點擊一次即可“要求發貨”，點擊兩次即可“在 Xmarket 上架”。',
          'zh-TW': '点击一次即可“请求发货”，点击两次即可“在 Xmarket 上架”。',
        },
        'コインへの合計還元数': {
          'en': 'Total number of returns to Coin',
          'ko': 'Coin에 대한 총 환원 수',
          'zh': '已兌換硬幣總數',
          'zh-TW': '已兑换硬币总数',
        },
        'Xmarketへ出品ボタンが押された商品は、出品リストに表示されます。そこで販売価格を決定してXmarketへ出品してください。': {
          'en': 'Once you press the "List on Xmarket" button, the item will be displayed in the list of items. You can then decide on a selling price and list it on Xmarket.',
          'ko': 'Xmarket에 전시 버튼이 눌러진 상품은 전시 리스트에 표시됩니다. 그래서 판매 가격을 결정하고 Xmarket에 출품하십시오.',
          'zh': '點擊「在Xmarket上架」按鈕後，商品將顯示在商品清單中。然後您可以確定售價並將其發佈到Xmarket。',
          'zh-TW': '点击“在Xmarket上架”按钮后，商品将显示在商品列表中。然后您可以确定售价并将其发布到Xmarket上。',
        },
        '最終確認へ': {
          'en': 'Go to final confirmation',
          'ko': '최종 확인에',
          'zh': '最終確認',
          'zh-TW': '最终确认',
        },
        '支払方法を選択': {
          'en': 'Select payment method',
          'ko': '지불 방법 선택',
          'zh': '選擇付款方式',
          'zh-TW': '选择付款方式',
        },
        '有効期限': {
          'en': 'date of expiry',
          'ko': '만료일',
          'zh': '到期日期',
          'zh-TW': '到期日期',
        },
        'セキュリティコード': {
          'en': 'security code',
          'ko': '보안 코드',
          'zh': '安全碼',
          'zh-TW': '安全码',
        },
        '住所1': {
          'en': 'Address Line 1',
          'ko': '주소 1',
          'zh': '地址第一行',
          'zh-TW': '地址第一行',
        },
        '住所2': {
          'en': 'Address 2',
          'ko': '주소 2',
          'zh': '地址 2',
          'zh-TW': '地址 2',
        },
        '会員登録': {
          'en': 'Member registration',
          'ko': '회원등록',
          'zh': '會員註冊',
          'zh-TW': '会员注册',
        },
        '枚セット': {
          'en': 'set of sheets',
          'ko': '매 세트',
          'zh': '一套10個',
          'zh-TW': '一套10个',
        },
        '申し込みへ': {
          'en': 'Go to application',
          'ko': '신청에',
          'zh': '立即申請',
          'zh-TW': '立即申请',
        },
        '会員ID': {
          'en': 'Member ID',
          'ko': '회원 ID',
          'zh': '會員編號',
          'zh-TW': '会员编号',
        },
        '会員ランク': {
          'en': 'Membership rank',
          'ko': '회원 등급',
          'zh': '會員等級',
          'zh-TW': '会员等级',
        },
        '次のランクまで': {
          'en': 'up to next rank',
          'ko': '다음 순위까지',
          'zh': '升至下一級',
          'zh-TW': '升至下一级',
        },
        '※ランクに応じた各種特典が受けられます': {
          'en': '*You can receive various benefits depending on your rank.',
          'ko': '※랭크에 따른 각종 특전을 받을 수 있습니다',
          'zh': '*根據您的級別，可享有各種福利。',
          'zh-TW': '*根据您的级别，可享受各种福利。',
        },
        '詳細': {
          'en': 'Detail',
          'ko': '상세',
          'zh': '細節',
          'zh-TW': '细节',
        },
        '友達紹介': {
          'en': 'refer-a-friend',
          'ko': '친구 소개',
          'zh': '推薦朋友',
          'zh-TW': '推荐朋友',
        },
        'あと': {
          'en': '',
          'ko': '나중에',
          'zh': '後',
          'zh-TW': '后',
        },
        '人紹介可能': {
          'en': ' friends you can refer',
          'ko': '사람 소개 가능',
          'zh': '可以介紹人',
          'zh-TW': '可以介绍人',
        },
        '紹介コード': {
          'en': 'Referral code',
          'ko': '추천 코드',
          'zh': '推薦碼',
          'zh-TW': '推荐码',
        },
        'コピー': {
          'en': 'copy',
          'ko': '복사',
          'zh': '複製',
          'zh-TW': '复制',
        },
        'あなたも友達も 500コインがもらえる': {
          'en': 'You and your friend will receive 500 coins',
          'ko': '당신과 친구 모두 500 동전을받을 수 있습니다.',
          'zh': '你和你的朋友將獲得 500 金幣',
          'zh-TW': '你和你的朋友将获得 500 金币',
        },
        '友達に会員登録をしてもらうとき、': {
          'en': 'Your friends has to enter your code',
          'ko': '친구가 귀하의 코드를 입력해야 합니다.',
          'zh': '您的朋友必須輸入您的代碼',
          'zh-TW': '您的朋友必须输入您的代码',
        },
        'あなたのコードを入力してもらう': {
          'en': 'when he or she registers as a member and then',
          'ko': '회원으로 등록한 후',
          'zh': '當他或她註冊為會員時，然後',
          'zh-TW': '当他或她注册为会员时，然后',
        },
        'その友達が': {
          'en': 'That friend completes',
          'ko': '그 친구가 완성했어요',
          'zh': '這位朋友完成了',
          'zh-TW': '这位朋友完成了',
        },
        'コインの購入': {
          'en': 'purchasing Coins',
          'ko': '코인 구매',
          'zh': '購買金幣',
          'zh-TW': '购买金币',
        },
        'クーポンを使う': {
          'en': 'Buy coins at a discount using coupons',
          'ko': '쿠폰으로 동전을 구매하세요',
          'zh': '使用優惠券以折扣價購買硬幣',
          'zh-TW': '使用优惠券以折扣价购买硬币',
        },
        'お知らせなどで配布': {
          'en': 'Distributed via Instagram and notifications',
          'ko': '인스타와 알림으로 배포',
          'zh': '透過 Instagram 和通知分發',
          'zh-TW': '通过 Instagram 和通知分发',
        },
        'クーポンコードを入力してください': {
          'en': 'Please enter the coupon code',
          'ko': '쿠폰 코드를 입력하세요.',
          'zh': '請輸入您的優惠券代碼',
          'zh-TW': '请输入您的优惠券代码',
        },
        '適用': {
          'en': 'Applicable',
          'ko': '적용',
          'zh': '適用的',
          'zh-TW': '适用的',
        },
        '動画を見てコインをもらう': {
          'en': 'Watch videos and get coins',
          'ko': '동영상을 보고 코인을 받으세요',
          'zh': '觀看影片即可獲得金幣',
          'zh-TW': '观看视频即可获得金币',
        },
        'Xmarket 出品リスト': {
          'en': 'My Xmarket list',
          'ko': '내 Xmarket 목록',
          'zh': '我的 Xmarket 列表',
          'zh-TW': '我的 Xmarket 列表',
        },
        'Appleとの連携に失敗しました。もう一度お試しください。': {
          'en': 'Failed to cooperate with Apple. Please try again.',
          'ko': 'Apple과의 협력에 실패했습니다. 다시 시도해 주세요.',
          'zh': '連接蘋果設備失敗。請重試。',
          'zh-TW': '连接苹果设备失败。请重试。',
        },
        '以下のURLから当サイト情報との紐付けを削除し再度お試し下さい。': {
          'en': 'Please remove the link to this site information from the URL below and try again.',
          'ko': '아래 URL에서 사이트 정보와의 연결을 삭제하고 다시 시도하십시오.',
          'zh': '請從以下網址中移除指向本網站的所有連結訊息，然後重試。',
          'zh-TW': '请从以下网址中移除指向本网站的所有链接信息，然后重试。',
        },
        'このアカウントは既に登録されています。ログインしてお楽しみください。': {
          'en': 'This account is already registered. Please log in and enjoy.',
          'ko': '이 계정은 이미 등록되어 있습니다.',
          'zh': '此帳號已註冊，請登入並享有服務。',
          'zh-TW': '此账号已注册，请登录并享受服务。',
        },
        'メールアドレスまたはパスワードが一致しません。': {
          'en': 'Email addresses or passwords do not match.',
          'ko': '이메일 주소 또는 비밀번호가 일치하지 않습니다.',
          'zh': '電子郵件地址或密碼不符。',
          'zh-TW': '电子邮件地址或密码不匹配。',
        },
        '利用規約': {
          'en': 'terms of service',
          'ko': '이용 약관',
          'zh': '服務條款',
          'zh-TW': '服务条款',
        },
        'に同意し、会員登録をします': {
          'en': 'I agree and register as a member.',
          'ko': '동의하고 회원 등록',
          'zh': '我同意以上條款，並註冊成為會員。',
          'zh-TW': '我同意以上条款，并注册成为会员。',
        },
        '住所は、「発送依頼」をされた際にご登録いただきます。': {
          'en': 'Please enter your address when you make your first shipping request.',
          'ko': '주소는, 최초의 「발송 의뢰」를 되었을 때에 입력해 주십니다.',
          'zh': '當您提交出貨請求時，我們會登記您的地址。',
          'zh-TW': '当您提交发货请求时，我们会登记您的地址。',
        },
        '利用規約に同意してください': {
          'en': 'Please agree to the terms of use',
          'ko': '이용 약관에 동의하십시오.',
          'zh': '請接受使用條款',
          'zh-TW': '请接受使用条款',
        },
        '会社概要': {
          'en': 'Company Profile',
          'ko': '회사개요',
          'zh': '公司簡介',
          'zh-TW': '公司简介',
        },
        '資金決済法': {
          'en': 'Fund settlement law',
          'ko': '자금결제법',
          'zh': '支付服務法案',
          'zh-TW': '支付服务法案',
        },
        '特定商取引法': {
          'en': 'Specified Commercial Transactions Law',
          'ko': '특정 상거래법',
          'zh': '特定商業交易法',
          'zh-TW': '特定商业交易法',
        },
        'ご利用ガイド': {
          'en': 'User guide',
          'ko': '이용 가이드',
          'zh': '使用者指南',
          'zh-TW': '用户指南',
        },
        '個人情報保護ポリシー': {
          'en': 'Privacy policy',
          'ko': '개인 정보 보호 정책',
          'zh': '個人資訊保護政策',
          'zh-TW': '个人信息保护政策',
        },
        '申し込み': {
          'en': 'application',
          'ko': '신청',
          'zh': '應用',
          'zh-TW': '应用',
        },
        'マイページ': {
          'en': 'My page',
          'ko': '내 페이지',
          'zh': '我的頁面',
          'zh-TW': '我的页面',
        },
        'コイン履歴': {
          'en': 'Coin history',
          'ko': '동전 이력',
          'zh': '硬幣歷史',
          'zh-TW': '硬币历史',
        },
        '商品購入履歴': {
          'en': 'Product purchase history',
          'ko': '상품 구매 이력',
          'zh': '產品購買歷史',
          'zh-TW': '产品购买历史',
        },
        'ログアウト': {
          'en': 'Logout',
          'ko': '로그아웃',
          'zh': '註銷',
          'zh-TW': '注销',
        },
        'コイン利用規約': {
          'en': 'Coin Terms of Use',
          'ko': '코인 이용 약관',
          'zh': '硬幣使用條款',
          'zh-TW': '硬币使用条款',
        },
        '資金決済法に基づく表記': {
          'en': 'Description based on the Payment Services Act',
          'ko': '자금결제법에 따른 표기',
          'zh': '根據《支付服務法》的描述',
          'zh-TW': '根据《支付服务法》的描述',
        },
        '特定商取引法に基づく表記': {
          'en': 'Description based on Specified Commercial Transactions Law',
          'ko': '특정 상거래법에 근거한 표기',
          'zh': '根據《特定商業交易法》的描述',
          'zh-TW': '根据《特定商业交易法》的描述',
        },
        '会員登録 / ログイン': {
          'en': 'Membership registration/login',
          'ko': '회원 등록 / 로그인',
          'zh': '會員註冊/登入',
          'zh-TW': '会员注册/登录',
        },
        'ガチャ履歴': {
          'en': 'Gacha history',
          'ko': '가챠 이력',
          'zh': '扭蛋史',
          'zh-TW': '扭蛋历史',
        },
        'コイン購入履歴': {
          'en': 'Coin purchase history',
          'ko': '동전 구매 내역',
          'zh': '硬幣購買歷史',
          'zh-TW': '硬币购买历史',
        },
        '買取履歴': {
          'en': 'Purchase history',
          'ko': '구매 내역',
          'zh': '購買歷史',
          'zh-TW': '购买历史',
        },
        '発送待ち': {
          'en': 'Waiting for shipment',
          'ko': '배송 대기',
          'zh': '等待發貨',
          'zh-TW': '等待发货',
        },
        '身分証(表)を設定してください': {
          'en': 'Please set your ID (front)',
          'ko': '신분증(표)을 설정해 주세요',
          'zh': '請設定您的ID（正面）',
          'zh-TW': '请设置您的ID（正面）',
        },
        '身分証(裏)を設定してください': {
          'en': 'Please set your ID (back)',
          'ko': '신분증(뒤)을 설정해 주세요',
          'zh': '請設定您的ID（返回）',
          'zh-TW': '请设置您的ID（返回）',
        },
        'お申し込みありがとうございます。お品物が到着次第、ご連絡いたします。引き続きどうぞよろしくお願いいたします。': {
          'en': 'Thank you for your application. We will contact you as soon as the item arrives. Thank you for your continued support.',
          'ko': '신청해 주셔서 감사합니다. 물건이 도착하는 대로 연락 드리겠습니다.',
          'zh': '感謝您的訂購。商品到貨後，我們會立即與您聯繫。感謝您一直以來的支持。',
          'zh-TW': '感谢您的订购。商品到货后，我们会立即与您联系。感谢您一直以来的支持。',
        },
        '価格帯': {
          'en': 'price range',
          'ko': '가격대',
          'zh': '價格範圍',
          'zh-TW': '价格范围',
        },
        'タイトル': {
          'en': 'title',
          'ko': '제목',
          'zh': '標題',
          'zh-TW': '标题',
        },
        '検索結果': {
          'en': 'Search results',
          'ko': '검색결과',
          'zh': '搜尋結果',
          'zh-TW': '搜索结果',
        },
        '手順確認': {
          'en': 'Check procedure',
          'ko': '절차 확인',
          'zh': '檢查該程式',
          'zh-TW': '检查该程序',
        },
        '買取申込': {
          'en': 'Purchase application',
          'ko': '구매 신청',
          'zh': '購買申請',
          'zh-TW': '购买申请',
        },
        '買取詳細履歴': {
          'en': 'Purchase details history',
          'ko': '구매 상세 내역',
          'zh': '購買詳情歷史記錄',
          'zh-TW': '购买详情历史记录',
        },
        '追跡番号': {
          'en': 'tracking number',
          'ko': '추적 번호',
          'zh': '追蹤號碼',
          'zh-TW': '追踪号码',
        },
        '発送業者': {
          'en': 'Shipping method',
          'ko': '배송 방법',
          'zh': '航運公司',
          'zh-TW': '航运公司',
        },
        '発送枚数': {
          'en': 'Number of shipments',
          'ko': '배송 수',
          'zh': '出貨次數',
          'zh-TW': '发货次数',
        },
        '査定額のお受け取り方法': {
          'en': 'How to receive the assessed amount',
          'ko': '평가 금액을 받는 방법',
          'zh': '如何取得估價',
          'zh-TW': '如何获取估价',
        },
        '口座情報': {
          'en': 'Account information',
          'ko': '계좌 정보',
          'zh': '帳號資訊',
          'zh-TW': '账户信息',
        },
        '銀行名': {
          'en': 'bank name',
          'ko': '은행 이름',
          'zh': '銀行名稱',
          'zh-TW': '银行名称',
        },
        '支店名': {
          'en': 'Branch name',
          'ko': '지점명',
          'zh': '分行名稱',
          'zh-TW': '分行名称',
        },
        '支店番号': {
          'en': 'Branch number',
          'ko': '지점 번호',
          'zh': '分行號',
          'zh-TW': '分行号',
        },
        '口座種別': {
          'en': 'Account type',
          'ko': '계좌 유형',
          'zh': '帳戶類型',
          'zh-TW': '账户类型',
        },
        '当座': {
          'en': 'current',
          'ko': '당좌',
          'zh': '目前的',
          'zh-TW': '当前的',
        },
        '名義': {
          'en': 'Name',
          'ko': '명의',
          'zh': '姓名',
          'zh-TW': '姓名',
        },
        '身分証アップロード': {
          'en': 'ID card upload',
          'ko': '신분증 업로드',
          'zh': '上傳您的身分證',
          'zh-TW': '上传您的身份证',
        },
        '表': {
          'en': 'table',
          'ko': '표',
          'zh': '桌子',
          'zh-TW': '桌子',
        },
        '裏(マイナンバーは表面のみ)': {
          'en': 'back',
          'ko': '뒤',
          'zh': '背面（我的號碼只在正面）',
          'zh-TW': '背面（我的号码只在正面）',
        },
        '買取フローを確認しました。その全てに同意します。': {
          'en': 'I have confirmed the purchase flow. I agree with all of that.',
          'ko': '구매 흐름을 확인했습니다. 그 모든 것에 동의합니다.',
          'zh': '我已仔細閱讀購買流程，並同意所有條款。',
          'zh-TW': '我已仔细阅读购买流程，并同意所有条款。',
        },
        '買取表': {
          'en': 'Purchase List',
          'ko': '매입표',
          'zh': '採購清單',
          'zh-TW': '采购清单',
        },
        '閉じる': {
          'en': 'close',
          'ko': '닫다',
          'zh': '關閉',
          'zh-TW': '关闭',
        },
        '買取手順': {
          'en': 'Purchase procedure',
          'ko': '구매 절차',
          'zh': '採購流程',
          'zh-TW': '采购流程',
        },
        '弊社へ査定依頼品の発送(発払い) & 買取申込フォームの送信': {
          'en': 'Send the item you wish to appraise to us (cash on delivery) and submit the purchase application form',
          'ko': '당사에 사정 의뢰품의 발송(발불) & 매입 신청 폼의 송신',
          'zh': '請將您要估價的物品寄給我們（貨到付款），並提交購買申請表。',
          'zh-TW': '请将您要估价的物品寄给我们（货到付款），并提交购买申请表。',
        },
        'メールにて査定結果の送信(到着後2営業日以内)': {
          'en': 'The appraisal results will be sent by email (within 2 business days of receipt)',
          'ko': '메일로 평가 결과 송신 (도착 후 2 영업일 이내)',
          'zh': '評估結果將透過電子郵件發送（收到後 2 個工作天內）。',
          'zh-TW': '评估结果将通过电子邮件发送（收到后 2 个工作日内）。',
        },
        'お振込(査定結果へのご同意後2営業日以内)': {
          'en': 'Payment (within 2 business days after agreeing to the assessment results)',
          'ko': '송금 (사정 결과에 동의 한 후 2 영업일 이내)',
          'zh': '付款（在同意評估結果後的 2 個工作天內）',
          'zh-TW': '付款（在同意评估结果后的 2 个工作日内）',
        },
        'ご留意事項': {
          'en': 'Notes',
          'ko': '유의사항',
          'zh': '重要通知',
          'zh-TW': '重要通知',
        },
        '1）買取表に掲載しているカードのみ買取可能です。': {
          'en': '1) Only cards listed on the purchase list can be purchased.',
          'ko': '1) 매입표에 게재하고 있는 카드만 매입 가능합니다.',
          'zh': '1）只能購買購買清單上的卡片。',
          'zh-TW': '1）只能购买采购清单上的卡片。',
        },
        '2）身分証は「運転免許証」「パスポート」「マイナンバー」のいずれかでお願いいたします。': {
          'en': '2) Please provide one of the following identification: driver\'s license, passport, or My Number.',
          'ko': '2) 신분증은 「운전 면허증」 「여권」 「마이 넘버」중 하나로 부탁드립니다.',
          'zh': '2）請提供以下身分證明之一：駕駛證、護照或My Number。',
          'zh-TW': '2）请提供以下身份证明之一：驾驶证、护照或My Number。',
        },
        '3）100枚までの発送、同名同種のカードは5枚まででお願いいたします。': {
          'en': '3) Please limit shipments to 100 cards, and limit shipments to 5 cards of the same name and type.',
          'ko': '3) 100장까지의 발송, 동명 동종의 카드는 5장까지로 부탁드리겠습니다.',
          'zh': '3）請將出貨數量限制在 100 張卡片以內，並將相同名稱和類型的卡片出貨數量限制在 5 張以內。',
          'zh-TW': '3）请将发货数量限制在 100 张卡片以内，并将相同名称和类型的卡片发货数量限制在 5 张以内。',
        },
        '4）偽物・状態が著しく悪いカード・買取表に掲載のないカードは査定不可となります。': {
          'en': '4) Counterfeits, cards in extremely poor condition, and cards not listed on the purchase list cannot be appraised.',
          'ko': '4) 가짜·상태가 현저하게 나쁜 카드·매입표에 게재가 없는 카드는 사정 불가가 됩니다.',
          'zh': '4) 假卡、品相極差的卡片、未列入購買清單的卡片無法進行估價。',
          'zh-TW': '4) 假卡、品相极差的卡片以及未列入购买清单的卡片无法进行估价。',
        },
        '5）返送をご希望の場合は、着払いにてご返送いたします。': {
          'en': '5) If you wish to return the item, we will ship it to you cash on delivery.',
          'ko': '5) 반송을 희망하시는 경우는, 수취인 지불로 반송하겠습니다.',
          'zh': '5) 如果您想退貨，我們將以貨到付款的方式寄送給您。',
          'zh-TW': '5) 如果您想退货，我们将以货到付款的方式寄送给您。',
        },
        '6）査定額は、到着時の価格となります。発送時にご確認いただいた価格と異なってしまう場合がございます。': {
          'en': '6) The assessed value will be the price at the time of arrival. It may differ from the price confirmed at the time of shipping.',
          'ko': '6) 평가 금액은 도착시 가격입니다. 배송시 확인하신 가격과 다를 수 있습니다.',
          'zh': '6) 評估價值將以到貨時的價格為準。該價格可能與發貨時確認的價格有所不同。',
          'zh-TW': '6) 评估价值将以到货时的价格为准。该价格可能与发货时确认的价格有所不同。',
        },
        '確認コードを入力してください': {
          'en': 'Please enter your verification code',
          'ko': '확인 코드를 입력하세요.',
          'zh': '請輸入您的驗證碼',
          'zh-TW': '请输入您的验证码',
        },
        '発送依頼日': {
          'en': 'Shipping request date',
          'ko': '배송 요청일',
          'zh': '出貨請求日期',
          'zh-TW': '发货请求日期',
        },
        '今月の課金額が {amount} 円未満のため、ご利用いただけません。': {
          'en': 'Cannot be used because this month\'s billing amount is less than {amount} yen.',
          'ko': '이달의 요금이 {amount} 엔 미만이므로 사용할 수 없습니다.',
          'zh': '由於本月的帳單金額少於 {amount} 日元，因此無法使用。',
          'zh-TW': '由于本月的账单金额少于 {amount} 日元，因此无法使用。',
        },
        'ユーザーエラー': {
          'en': 'User error',
          'ko': '사용자 오류',
          'zh': '使用者錯誤',
          'zh-TW': '用户错误',
        },
        '該当する商品が存在しません。': {
          'en': 'There is no corresponding product.',
          'ko': '해당 상품이 존재하지 않습니다.',
          'zh': '沒有對應的產品。',
          'zh-TW': '没有对应的产品。',
        },
        '対象地域ではありません。': {
          'en': 'It is not a target area.',
          'ko': '대상 지역이 아닙니다.',
          'zh': '這裡不是目標區域。',
          'zh-TW': '这里不是目标区域。',
        },
        'このガチャは、{rank}ランクの方はご購入できません。': {
          'en': 'This gacha cannot be purchased by those of {rank} rank.',
          'ko': '이 가챠는 {rank} 랭크의 분은 구입할 수 없습니다.',
          'zh': '{rank} 等級的玩家無法購買此扭蛋。',
          'zh-TW': '{rank} 等级的玩家无法购买此扭蛋。',
        },
        'このガチャは総保有コインが{max_point_limit}コイン以上の場合は購入できません。\n※未選択のものも含みます。': {
          'en': 'This gacha cannot be purchased if the total coins you own are more than {max_point_limit}coins. \n*Includes unselected items.',
          'ko': '이 가챠는 총 보유 코인이 {max_point_limit}coins 이상인 경우는 구입할 수 없습니다.',
          'zh': '如果您擁有的金幣總數超過 {max_point_limit} 個金幣，則無法購買此扭蛋。 \n*包含未選擇的項目。',
          'zh-TW': '如果您拥有的金币总数超过 {max_point_limit} 个金币，则无法购买此扭蛋。 \n*包括未选择的项目。',
        },
        'お客様は本商品をご利用いただける条件を満たしていないため、ご利用いただけません。\n条件等の公開はいたしかねますこと、ご容赦くださいませ。': {
          'en': 'You are unable to use this product because you do not meet the conditions for use. We apologize for the inconvenience, but we are unable to disclose the conditions.',
          'ko': '고객은 본 제품을 이용하실 수 있는 조건을 충족하지 않으므로 이용하실 수 없습니다. \n조건등의 공개는 하기 어렵습니다, 용서해 주십시오.',
          'zh': '您無法使用此產品，因為您不符合使用條件。對此造成的不便，我們深表歉意，但我們無法透露具體使用條件。',
          'zh-TW': '您无法使用此产品，因为您不符合使用条件。对此造成的不便，我们深表歉意，但我们无法透露具体使用条件。',
        },
        'このガチャは1度までです。': {
          'en': 'This gacha can only be used once.',
          'ko': '이 뽑기는 1도까지입니다.',
          'zh': '此扭蛋只能使用一次。',
          'zh-TW': '此扭蛋只能使用一次。',
        },
        '{detetime}まで購入できません。': {
          'en': 'Purchases cannot be made until {detetime}.',
          'ko': '{detetime}까지 구매할 수 없습니다.',
          'zh': '在{detetime}之前無法進行購買。',
          'zh-TW': '在{detetime}之前无法进行购买。',
        },
        '購入可能数をオーバーしています。': {
          'en': 'You have exceeded the number of items that can be purchased.',
          'ko': '구매 가능한 수를 초과했습니다.',
          'zh': '您購買的商品數量已超過上限。',
          'zh-TW': '您购买的商品数量已超过上限。',
        },
        '入力してください': {
          'en': 'Please enter',
          'ko': '입력해주세요',
          'zh': '請輸入',
          'zh-TW': '请输入',
        },
        '形式が不正です': {
          'en': 'Invalid format',
          'ko': '형식이 잘못되었습니다.',
          'zh': '格式無效',
          'zh-TW': '格式无效',
        },
        '半角英数字で入力してください': {
          'en': 'Please enter in half-width alphanumeric characters',
          'ko': '반각 영숫자로 입력하세요.',
          'zh': '請輸入半角字母數字字符',
          'zh-TW': '请输入半角字母数字字符',
        },
        '半角英数記号で入力してください': {
          'en': 'Please enter using half-width alphanumeric characters.',
          'ko': '반각 영숫자 기호로 입력하십시오.',
          'zh': '請使用半角字母數字字元輸入。',
          'zh-TW': '请使用半角字母数字字符输入。',
        },
        '%d文字以内で入力してください': {
          'en': 'Please enter within %d characters',
          'ko': '%d자 이내로 입력하세요.',
          'zh': '請在 %d 個字元以內輸入',
          'zh-TW': '请在 %d 个字符以内输入',
        },
        '%d文字以上で入力してください': {
          'en': 'Please enter at least %d characters',
          'ko': '%d자 이상으로 입력하세요.',
          'zh': '請輸入至少 %d 個字符',
          'zh-TW': '请输入至少 %d 个字符',
        },
        '既に使われています': {
          'en': 'Already in use',
          'ko': '이미 사용 중',
          'zh': '已在使用中',
          'zh-TW': '已在使用中',
        },
        'カタカナで入力してください': {
          'en': 'Please enter in katakana',
          'ko': '카타카나로 입력하세요',
          'zh': '請用片假名輸入。',
          'zh-TW': '请用片假名输入。',
        },
        'ひらがなで入力してください': {
          'en': 'Please enter in hiragana',
          'ko': '히라가나로 입력하십시오.',
          'zh': '請用平假名輸入。',
          'zh-TW': '请用平假名输入。',
        },
        '%d以上で入力してください': {
          'en': 'Please enter at least %d',
          'ko': '%d 이상으로 입력하세요.',
          'zh': '請至少輸入 %d',
          'zh-TW': '请至少输入 %d',
        },
        'コードが一致しません': {
          'en': 'Code does not match',
          'ko': '코드가 일치하지 않음',
          'zh': '代碼不匹配',
          'zh-TW': '代码不匹配',
        },
        '該当ユーザーなし': {
          'en': 'No matching users',
          'ko': '해당 사용자 없음',
          'zh': '沒有匹配的用戶',
          'zh-TW': '没有匹配的用户',
        },
        'パスワードが一致しません': {
          'en': 'Passwords do not match',
          'ko': '비밀번호가 일치하지 않음',
          'zh': '密碼不匹配',
          'zh-TW': '密码不匹配',
        },
        '紹介コードが無効です': {
          'en': 'Invalid referral code',
          'ko': '추천 코드가 잘못되었습니다.',
          'zh': '無效的推薦碼',
          'zh-TW': '无效的推荐码',
        },
        '紹介コードを入力してください': {
          'en': 'Enter your referral code',
          'ko': '추천 코드를 입력하세요.',
          'zh': '輸入您的推薦碼',
          'zh-TW': '输入您的推荐码',
        },
        'パスワード確認用と一致しません': {
          'en': 'Password confirmation does not match',
          'ko': '비밀번호 확인과 일치하지 않음',
          'zh': '密碼確認不匹配',
          'zh-TW': '密码确认不匹配',
        },
        'ユーザーが一致しません': {
          'en': 'User does not match',
          'ko': '사용자가 일치하지 않음',
          'zh': '用戶不匹配',
          'zh-TW': '用户不匹配',
        },
        '支払い方法が一致しません': {
          'en': 'Payment method does not match',
          'ko': '결제 방법이 일치하지 않음',
          'zh': '付款方式不符',
          'zh-TW': '付款方式不匹配',
        },
        'この電話番号は既に登録されています': {
          'en': 'This phone number is already registered',
          'ko': '이 전화번호는 이미 등록되어 있습니다.',
          'zh': '此電話號碼已註冊',
          'zh-TW': '此电话号码已注册',
        },
        'この電話番号は利用できません。': {
          'en': 'This phone number is not available.',
          'ko': '이 전화번호는 사용할 수 없습니다.',
          'zh': '此電話號碼不可用。',
          'zh-TW': '此电话号码不可用。',
        },
        'コードが一致しませんでした': {
          'en': 'The code did not match',
          'ko': '코드가 일치하지 않습니다.',
          'zh': '代碼不匹配',
          'zh-TW': '代码不匹配',
        },
        '有効期限が切れています': {
          'en': 'Expired',
          'ko': '만료됨',
          'zh': '已到期',
          'zh-TW': '已到期',
        },
        'コード認証に失敗しました': {
          'en': 'Code verification failed',
          'ko': '코드 인증에 실패했습니다.',
          'zh': '程式碼驗證失敗',
          'zh-TW': '代码验证失败',
        },
        '不正なリクエストです': {
          'en': 'Bad request',
          'ko': '잘못된 요청입니다.',
          'zh': '錯誤的請求',
          'zh-TW': '错误的请求',
        },
        'エラーが発生しました': {
          'en': 'An error has occurred',
          'ko': '오류가 발생했습니다.',
          'zh': '發生錯誤',
          'zh-TW': '发生错误',
        },
        '既にランクを維持しています': {
          'en': 'Already maintaining a rank',
          'ko': '이미 순위를 유지하고 있습니다.',
          'zh': '已保持排名',
          'zh-TW': '已保持排名',
        },
        'ログインしてください。': {
          'en': 'Please log in.',
          'ko': '로그인하십시오.',
          'zh': '請登入。',
          'zh-TW': '请登录。',
        },
        'クーポンコードが間違っています。\n正しいコードを入力してください。': {
          'en': 'The coupon code is incorrect.\nPlease enter the correct code.',
          'ko': '쿠폰 코드가 잘못되었습니다. \n올바른 코드를 입력하세요.',
          'zh': '優惠券代碼不正確。 \n請輸入正確的代碼。',
          'zh-TW': '优惠券代码不正确。\n请输入正确的代码。',
        },
        'クーポンコードの期限が切れています。\n正しいコードを入力してください。': {
          'en': 'The coupon code has expired.\nPlease enter the correct code.',
          'ko': '쿠폰 코드가 만료되었습니다. \n올바른 코드를 입력하세요.',
          'zh': '優惠券代碼已過期。 \n請重新輸入正確的代碼。',
          'zh-TW': '优惠券代码已过期。\n请重新输入正确的代码。',
        },
        'クーポンコードの利用条件が満たされていません。\n正しいコードを入力してください。': {
          'en': 'The coupon code usage conditions have not been met.\nPlease enter the correct code.',
          'ko': '쿠폰 코드 이용 약관이 충족되지 않았습니다. \n올바른 코드를 입력하세요.',
          'zh': '優惠券代碼的使用條件尚未滿足。 \n請輸入正確的代碼。',
          'zh-TW': '优惠券代码的使用条件尚未满足。\n请输入正确的代码。',
        },
        'クーポンコードの利用回数が上限に達しています。\n新しいコードを入力してください。': {
          'en': 'The coupon code has reached its limit. Please enter a new code.',
          'ko': '쿠폰 코드 이용 횟수가 상한에 도달했습니다. \n새 코드를 입력하세요.',
          'zh': '優惠券代碼已用完，請輸入新的代碼。',
          'zh-TW': '优惠券代码已用完，请输入新的代码。',
        },
        '既に使用済みのクーポンコードです。\n新しいコードを入力してください。': {
          'en': 'This coupon code has already been used.\nPlease enter a new code.',
          'ko': '이미 사용한 쿠폰 코드입니다. \n새 코드를 입력하세요.',
          'zh': '此優惠碼已被使用。 \n請輸入新的優惠碼。',
          'zh-TW': '此优惠码已被使用。\n请输入新的优惠码。',
        },
        'コインプレゼントが見つかりません': {
          'en': 'I can\'t find the coin gift',
          'ko': '동전 선물을 찾을 수 없습니다.',
          'zh': '我找不到那枚硬幣禮物了。',
          'zh-TW': '我找不到那枚硬币礼物了。',
        },
        'コインプレゼントが適用されていません': {
          'en': 'Coin gift not applied',
          'ko': '코인 선물이 적용되지 않음',
          'zh': '未享有贈幣優惠',
          'zh-TW': '未享受赠币优惠',
        },
        '該当するガチャが存在しません': {
          'en': 'There is no matching gacha',
          'ko': '해당 가챠가 존재하지 않습니다.',
          'zh': '沒有匹配的扭蛋',
          'zh-TW': '没有匹配的扭蛋',
        },
        '購入可能数をオーバーしています': {
          'en': 'You have exceeded the number of items you can purchase.',
          'ko': '구매 가능한 수를 초과했습니다.',
          'zh': '您購買的商品數量已超過限額。',
          'zh-TW': '您购买的商品数量已超过限额。',
        },
        '最大購入数を超えています': {
          'en': 'You have exceeded the maximum purchase quantity',
          'ko': '최대 구매 수를 초과함',
          'zh': '您已超過最大購買數量',
          'zh-TW': '您已超过最大购买数量',
        },
        '購入データが見つかりませんでした': {
          'en': 'No purchase data found',
          'ko': '구매 데이터를 찾을 수 없습니다.',
          'zh': '未找到購買數據',
          'zh-TW': '未找到购买数据',
        },
        '既に選択済みです': {
          'en': 'Already selected',
          'ko': '이미 선택됨',
          'zh': '已選擇',
          'zh-TW': '已选择',
        },
        '動画が見つかりません': {
          'en': 'Video not found',
          'ko': '동영상을 찾을 수 없음',
          'zh': '影片未找到',
          'zh-TW': '视频未找到',
        },
        '既に視聴済みです': {
          'en': 'Already watched',
          'ko': '이미 시청됨',
          'zh': '已觀看',
          'zh-TW': '已观看',
        },
        '販売者募集': {
          'en': 'Seller Recruitment',
          'ko': '판매자 모집',
          'zh': '賣家招募',
          'zh-TW': '卖家招募',
        },
        '遊び方': {
          'en': 'How to play',
          'ko': '놀이 방법',
          'zh': '如何玩',
          'zh-TW': '如何玩',
        },
        '残数': {
          'en': 'residue',
          'ko': '잔여물',
          'zh': '渣滓',
          'zh-TW': '残渣',
        },
        'コインを': {
          'en': 'Coin',
          'ko': '동전',
          'zh': '硬幣',
          'zh-TW': '硬币',
        },
        '消費して': {
          'en': 'Consume',
          'ko': '소모하다',
          'zh': '消耗',
          'zh-TW': '消耗',
        },
        'Xmarketは近日公開致します': {
          'en': 'Xmarket will be released soon',
          'ko': 'Xmarket은 곧 공개됩니다.',
          'zh': 'Xmarket即將上線',
          'zh-TW': 'Xmarket即将上线',
        },
        'お振込み': {
          'en': 'Bank transfer',
          'ko': '송금',
          'zh': '銀行轉帳',
          'zh-TW': '银行转账',
        },
        'コインで受け取り': {
          'en': 'Receive with coins',
          'ko': '동전으로 받기',
          'zh': '用金幣領取',
          'zh-TW': '用金币领取',
        },
        '普通': {
          'en': 'usually',
          'ko': '보통',
          'zh': '通常',
          'zh-TW': '通常',
        },
        'ホワイト': {
          'en': 'white',
          'ko': '화이트',
          'zh': '白色的',
          'zh-TW': '白色的',
        },
        'ブロンズ': {
          'en': 'bronze',
          'ko': '청동',
          'zh': '青銅',
          'zh-TW': '青铜',
        },
        'シルバー': {
          'en': 'Silver',
          'ko': '실버',
          'zh': '銀',
          'zh-TW': '银',
        },
        'ゴールド': {
          'en': 'gold',
          'ko': '금',
          'zh': '金子',
          'zh-TW': '金子',
        },
        'レインボー': {
          'en': 'Rainbow',
          'ko': '레인보우',
          'zh': '彩虹',
          'zh-TW': '彩虹',
        },
        'ブラック': {
          'en': 'black',
          'ko': '블랙',
          'zh': '黑色的',
          'zh-TW': '黑色的',
        },
        'まで': {
          'en': 'to',
          'ko': '까지',
          'zh': '到',
          'zh-TW': '到',
        },
        '画像ファイルのみアップロードできます。': {
          'en': 'Only image files can be uploaded.',
          'ko': '이미지 파일만 업로드할 수 있습니다.',
          'zh': '僅支援上傳圖片檔案。',
          'zh-TW': '仅支持上传图片文件。',
        },
        '動画視聴': {
          'en': 'Video viewing',
          'ko': '동영상 시청',
          'zh': '影片觀看',
          'zh-TW': '视频观看',
        },
        'コイン還元': {
          'en': 'Coin return',
          'ko': '동전 환원',
          'zh': '硬幣返回',
          'zh-TW': '硬币返回',
        },
        '商品購入': {
          'en': 'Product purchase',
          'ko': '상품 구매',
          'zh': '產品購買',
          'zh-TW': '产品购买',
        },
        '未選択': {
          'en': 'Unselected',
          'ko': '선택되지 않음',
          'zh': '未選取',
          'zh-TW': '未选中',
        },
        '発送なし': {
          'en': 'No shipping',
          'ko': '배송 없음',
          'zh': '不出貨',
          'zh-TW': '不发货',
        },
        '発送済み': {
          'en': 'Shipped',
          'ko': '배송됨',
          'zh': '已出貨',
          'zh-TW': '已发货',
        },
        '※発送先のご住所は初めて発送依頼いただく際にご登録いただきます': {
          'en': '*You will need to register your shipping address when you first request shipping.',
          'ko': '※발송처의 주소는 처음으로 발송 의뢰할 때에 등록해 주십니다',
          'zh': '*首次申請出貨時，您需要註冊您的收貨地址。',
          'zh-TW': '*首次申请发货时，您需要注册您的收货地址。',
        },
        '%d日': {
          'en': '%d days',
          'ko': '%d일',
          'zh': '%d 天',
          'zh-TW': '%d 天',
        },
        'まで販売': {
          'en': 'On sale until',
          'ko': '까지 판매',
          'zh': '促銷活動持續進行中',
          'zh-TW': '促销活动持续进行中',
        },
        '{year}/{month}/{day} まで販売': {
          'en': 'On sale until {year}/{month}/{day} JST',
          'ko': '{year}/{month}/{day} 까지 판매 JST',
          'zh': '促銷至 {year}/{month}/{day} JST',
          'zh-TW': '促销至 {year}/{month}/{day} JST',
        },
        '個人情報を変更希望の際は、チャットにてお問い合わせください': {
          'en': 'If you wish to change your personal information, please contact us via chat.',
          'ko': '개인 정보를 변경하고 싶을 때는 채팅으로 문의하십시오.',
          'zh': '如果您想更改您的個人訊息，請透過聊天與我們聯繫。',
          'zh-TW': '如果您想更改您的个人信息，请通过聊天联系我们。',
        },
        '購入': {
          'en': 'Purchase',
          'ko': '구매',
          'zh': '購買',
          'zh-TW': '购买',
        },
        '詳細へ': {
          'en': 'Detail',
          'ko': '상세',
          'zh': '細節',
          'zh-TW': '细节',
        },
        '%d回限定': {
          'en': 'Limited to %d times',
          'ko': '%d회 한정',
          'zh': '限時 %d 次',
          'zh-TW': '限时 %d 次',
        },
        '株式会社ゼロプレイス': {
          'en': '',
          'ko': '',
          'zh': '',
          'zh-TW': '',
        },
        'Xero Place Co., Ltd.': {
          'en': 'Xero Place Co., Ltd.',
          'ko': 'Xero Place Co., Ltd.',
          'zh': 'Xero Place有限公司',
          'zh-TW': 'Xero Place有限公司',
        },
        '〒330-0854': {
          'en': '〒330-0854',
          'ko': '〒330-0854',
          'zh': '〒330-0854',
          'zh-TW': '〒330-0854',
        },
        '埼玉県さいたま市大宮区桜木町1丁目195‑1': {
          'en': '1-195-1 Sakuragicho, Omiya Ward, Saitama City, Saitama Prefecture',
          'ko': '사이타마현 사이타마시 오미야구 사쿠라기초 1가 195-1',
          'zh': '埼玉縣埼玉市大宮區櫻木町1-195-1',
          'zh-TW': '埼玉县埼玉市大宫区樱木町1-195-1',
        },
        '大宮ソラミチKOZ4階　株式会社ゼロプレイス　買取受付担当宛': {
          'en': 'Omiya Soramichi KOZ 4th floor Zero Place Co., Ltd. Purchase Reception',
          'ko': '오미야 소라미치 KOS 4층 주식회사 제로 플레이스 매입 접수 담당 앞',
          'zh': '大宮空道 KOZ 4樓 Zero Place Co., Ltd. 採購接待處',
          'zh-TW': '大宫空道 KOZ 4楼 Zero Place Co., Ltd. 采购接待处',
        },
        'TEL：050-1724-5360': {
          'en': 'TEL : +81 50-1724-5360',
          'ko': 'TEL  : +81 50-1724-5360',
          'zh': '電話：+81 50-1724-5360',
          'zh-TW': '电话：+81 50-1724-5360',
        },
        '{year}/{month}/{day} 以降の登録': {
          'en': 'Registration after {year}/{month}/{day}',
          'ko': '{year}/{month}/{day} 이후 등록',
          'zh': '{year}/{month}/{day}後註冊',
          'zh-TW': '{year}/{month}/{day}后注册',
        },
        '{year}/{month}/{day} 以前の登録': {
          'en': 'Registrations before {year}/{month}/{day}',
          'ko': '{year}/{month}/{day} 이전 등록',
          'zh': '{year}/{month}/{day}之前註冊',
          'zh-TW': '{year}/{month}/{day}之前注册',
        },
        '今月{amount}コイン以上決済された方限定': {
          'en': 'This month\'s {amount} spenders',
          'ko': '이번 달 {amount}Coins 이상 결제된 분 한정',
          'zh': '僅限本月支付超過 {amount}Coins 的用戶',
          'zh-TW': '仅限本月支付超过 {amount} 枚金币的用户',
        },
        '所持{amount}コイン以下の方限定': {
          'en': '{amount} Coins or less',
          'ko': '소지 {amount}Coins 이하의 분 한정',
          'zh': '僅限擁有 {amount} 金幣或更少的人',
          'zh-TW': '仅限拥有少于 {amount} 枚硬币的用户',
        },
        '1日%d回限定': {
          'en': 'Limited to %d times per day',
          'ko': '1일 %d회 한정',
          'zh': '每天限用 %d 次',
          'zh-TW': '每天限用 %d 次',
        },
        '言語': {
          'en': 'language',
          'ko': '언어',
          'zh': '語言',
          'zh-TW': '语言',
        },
        '言語を選択してください': {
          'en': 'Select a Language',
          'ko': '언어를 선택하세요',
          'zh': '選擇語言',
          'zh-TW': '选择语言',
        },
        '未選択一覧': {
          'en': 'Unselected list',
          'ko': '선택되지 않은 목록',
          'zh': '未選取列表',
          'zh-TW': '未选中列表',
        },
        '¥': {
          'en': '¥',
          'ko': '¥',
          'zh': '¥',
          'zh-TW': '¥',
        },
        'システムエラーが発生しました。': {
          'en': 'A system error has occurred.',
          'ko': '시스템 오류가 발생했습니다.',
          'zh': '系統發生錯誤。',
          'zh-TW': '系统发生错误。',
        },
        '発送済み一覧': {
          'en': 'Shipped List',
          'ko': '배송된 목록',
          'zh': '出貨清單',
          'zh-TW': '发货清单',
        },
        '選択する': {
          'en': 'Select',
          'ko': '선택',
          'zh': '選擇',
          'zh-TW': '选择',
        },
        '1タップで「発送依頼」': {
          'en': '"Request shipping" with one tap',
          'ko': '1 탭으로 「발송 의뢰」',
          'zh': '一鍵“請求發貨”',
          'zh-TW': '一键“请求发货”',
        },
        '2タップで「X marketで販売」（近日公開）となります。': {
          'en': 'With two taps, you can "Sell on X market" (coming soon).',
          'ko': '2 탭으로 「X market에서 판매」(곧 공개)가 됩니다.',
          'zh': '只需輕點兩下，即可「在 X 市場出售」（即將推出）。',
          'zh-TW': '只需轻点两下，即可“在 X 市场出售”（即将推出）。',
        },
        '本商品の内容は全て非公開となります。': {
          'en': 'All contents of this product will be kept confidential.',
          'ko': '본 상품의 내용은 모두 비공개입니다.',
          'zh': '本產品的所有內容將保密。',
          'zh-TW': '本产品的所有内容都将保密。',
        },
        '視聴上限人数を超えました': {
          'en': 'The maximum number of viewers has been exceeded',
          'ko': '시청 상한 인원을 초과했습니다.',
          'zh': '已超過最大觀看人數',
          'zh-TW': '已超过最大观看人数',
        },
        '詳細はこちら': {
          'en': 'Detail',
          'ko': '상세',
          'zh': '細節',
          'zh-TW': '细节',
        },
        '買取コイン': {
          'en': 'when you sold it to us',
          'ko': '우리에게 팔았을 때',
          'zh': '當你把它賣給我們時',
          'zh-TW': '当你把它卖给我们时',
        },
        'コインへ還元': {
          'en': 'Return to coin',
          'ko': '동전으로 환원',
          'zh': '返回硬幣',
          'zh-TW': '返回硬币',
        },
        '買取ボーナス': {
          'en': 'Bonus to sell to us',
          'ko': '우리에게 판매하는 보너스',
          'zh': '賣給我們的獎金',
          'zh-TW': '卖给我们的奖金',
        },
        'ログイン状態を保持する': {
          'en': 'Stay logged in',
          'ko': '로그인 상태 유지',
          'zh': '保持登入狀態',
          'zh-TW': '保持登录状态',
        },
        'パスワードをお忘れですか？': {
          'en': 'Forgot your password?',
          'ko': '비밀번호를 잊으셨습니까?',
          'zh': '忘記密碼了嗎？',
          'zh-TW': '忘记密码了吗？',
        },
        '姓': {
          'en': 'Last name',
          'ko': '성',
          'zh': '姓',
          'zh-TW': '姓',
        },
        'ミドルネーム': {
          'en': 'middle name',
          'ko': '중간 이름',
          'zh': '中間名字',
          'zh-TW': '中间名字',
        },
        '名': {
          'en': 'first name',
          'ko': '첫 번째 이름',
          'zh': '名',
          'zh-TW': '名',
        },
        'パスワード確認': {
          'en': 'Confirm password',
          'ko': '비밀번호 확인',
          'zh': '確認密碼',
          'zh-TW': '确认密码',
        },
        '紹介コードをお持ちの方': {
          'en': 'Those who have a friend referral code',
          'ko': '친구 소개 코드를 가지고 계신 분',
          'zh': '擁有朋友推薦碼的人',
          'zh-TW': '拥有朋友推荐码的人',
        },
        '遊戯王': {
          'en': 'Yu-Gi-Oh!',
          'ko': '유희왕',
          'zh': '遊戲王',
          'zh-TW': '游戏王',
        },
        'ヴァイスシュバルツ': {
          'en': 'Weiss Schwarz',
          'ko': '바이스슈바르츠',
          'zh': '魏斯·施瓦茨',
          'zh-TW': '魏斯·施瓦茨',
        },
        'ワンピース': {
          'en': 'One piece',
          'ko': '원피스',
          'zh': '一塊',
          'zh-TW': '一块',
        },
        'ポケモン': {
          'en': 'Pokémon',
          'ko': '포켓몬',
          'zh': '寶可夢',
          'zh-TW': '宝可梦',
        },
        '※現金+査定額の1%分のコイン': {
          'en': '*Cash + 1% of the assessed value in coins',
          'ko': '※현금+사정액의 1%분의 코인',
          'zh': '*現金 + 評估價值的 1%（以硬幣形式支付）',
          'zh-TW': '*现金 + 评估价值的 1%（以硬币形式支付）',
        },
        '※査定額の110%分のコイン': {
          'en': '* Coins worth 110% of the assessed value',
          'ko': '※사정액의 110%분의 코인',
          'zh': '* 硬幣價值為評估價值的110%',
          'zh-TW': '* 硬币价值为评估价值的110%',
        },
        'パスワード': {
          'en': 'password',
          'ko': '비밀번호',
          'zh': '密碼',
          'zh-TW': '密码',
        },
        '現在のランクは「{rank}」です。': {
          'en': 'Current rank is "{rank}".',
          'ko': '현재 순위는 \'{rank}\'입니다.',
          'zh': '目前排名是“{rank}”。',
          'zh-TW': '当前排名是“{rank}”。',
        },
        'コインを使用しない場合、来月は「{rank}」ランクになります。': {
          'en': 'If you do not use Coin, you will be ranked as "White" next month.',
          'ko': '코인을 사용하지 않으면 다음 달은 "화이트"랭크가됩니다.',
          'zh': '如果你不使用你的硬幣，你將在下個月被評為「白」。',
          'zh-TW': '如果你不使用你的硬币，你将在下个月被评为“白”。',
        },
        '来月、「{rank}」からスタートするには {amount} コインが必要です。': {
          'en': 'You will need {amount} Coins to start at "{rank}" next month.',
          'ko': '다음 달 "{rank}"에서 시작하려면 {amount} Coins가 필요합니다.',
          'zh': '您將需要 {amount} 金幣才能在下個月達到「{rank}」。',
          'zh-TW': '您将需要 {amount} 金币才能在下个月达到“{rank}”。',
        },
        'すでにランク維持を完了しています。': {
          'en': 'You have already completed rank maintenance.',
          'ko': '이미 순위 유지를 완료했습니다.',
          'zh': '您已經完成了等級維護。',
          'zh-TW': '您已经完成了等级维护。',
        },
        '未選択のお品物は24時間でコインへ自動変換されます': {
          'en': 'Unselected items will be automatically converted to coins within 24 hours.',
          'ko': '선택되지 않은 상품은 24시간 내에 동전으로 자동 변환됩니다.',
          'zh': '未選擇的物品將在24小時內自動轉換為金幣。',
          'zh-TW': '未选择的物品将在24小时内自动转换为金币。',
        },
        'ランク維持してよろしいですか': {
          'en': 'Do you want to maintain your rank?',
          'ko': '순위를 유지하시겠습니까?',
          'zh': '你想保持你的軍階嗎？',
          'zh-TW': '你想保持你的军衔吗？',
        },
        'ランク維持確認': {
          'en': 'Rank maintenance confirmation',
          'ko': '랭크 유지 확인',
          'zh': '等級維持確認',
          'zh-TW': '等级维持确认',
        },
        '支払う': {
          'en': 'pay',
          'ko': '지불하다',
          'zh': '支付',
          'zh-TW': '支付',
        },
        'ランク維持': {
          'en': 'Maintain rank',
          'ko': '랭크 유지',
          'zh': '保持排名',
          'zh-TW': '保持排名',
        },
        'ランク維持が完了しました': {
          'en': 'Rank maintenance completed',
          'ko': '순위 유지가 완료되었습니다.',
          'zh': '等級維護完成',
          'zh-TW': '等级维护完成',
        },
        '{num}枚セット': {
          'en': '{num} set',
          'ko': '{num}매 세트',
          'zh': '{num} 件套裝',
          'zh-TW': '{num} 件套装',
        },
        '州': {
          'en': 'state',
          'ko': '주',
          'zh': '狀態',
          'zh-TW': '状态',
        },
        'この販売者のガチャ一覧': {
          'en': 'This seller\'s gacha list',
          'ko': '이 판매자의 뽑기 목록',
          'zh': '該賣家的扭蛋列表',
          'zh-TW': '该卖家的扭蛋列表',
        },
        'まだ販売されている商品がありません': {
          'en': 'There are no products for sale yet',
          'ko': '아직 판매되는 상품이 없습니다.',
          'zh': '目前還沒有商品出售。',
          'zh-TW': '目前还没有商品出售。',
        },
        '入力情報を確認': {
          'en': 'Check the input information',
          'ko': '입력 정보 확인',
          'zh': '檢查輸入訊息',
          'zh-TW': '检查输入信息',
        },
        '送信': {
          'en': 'send',
          'ko': '전송',
          'zh': '傳送',
          'zh-TW': '发送',
        },
        '販売者一覧': {
          'en': 'Seller List',
          'ko': '판매자 목록',
          'zh': '賣家列表',
          'zh-TW': '卖家列表',
        },
        'ホビー系': {
          'en': 'Hobby',
          'ko': '취미계',
          'zh': '嗜好',
          'zh-TW': '爱好',
        },
        'アイドル': {
          'en': 'idol',
          'ko': '아이돌',
          'zh': '偶像',
          'zh-TW': '偶像',
        },
        'お酒': {
          'en': 'Alcohol',
          'ko': '술',
          'zh': '酒精',
          'zh-TW': '酒精',
        },
        '電子機器': {
          'en': 'electronic equipment',
          'ko': '전자기기',
          'zh': '電子設備',
          'zh-TW': '电子设备',
        },
        '釣り': {
          'en': 'fishing',
          'ko': '낚시',
          'zh': '釣魚',
          'zh-TW': '钓鱼',
        },
        '宝石': {
          'en': 'jewelry ',
          'ko': '보석',
          'zh': '珠寶',
          'zh-TW': '珠宝 ',
        },
        '食べ物': {
          'en': 'food',
          'ko': '음식',
          'zh': '食物',
          'zh-TW': '食物',
        },
        'ご当地': {
          'en': 'Local',
          'ko': '현지',
          'zh': '當地的',
          'zh-TW': '当地的',
        },
        'アニメ': {
          'en': 'anime',
          'ko': '애니메이션',
          'zh': '日本卡通',
          'zh-TW': '日本动画片',
        },
        'スニーカー': {
          'en': 'sneakers',
          'ko': '운동화',
          'zh': '運動鞋',
          'zh-TW': '运动鞋',
        },
        'ブランド': {
          'en': 'brand',
          'ko': '브랜드',
          'zh': '品牌',
          'zh-TW': '品牌',
        },
        'パスワード入力': {
          'en': 'Password entry',
          'ko': '비밀번호 입력',
          'zh': '密碼輸入',
          'zh-TW': '密码输入',
        },
        'パスワードは必須です。': {
          'en': 'A password is required.',
          'ko': '암호는 필수입니다.',
          'zh': '需要密碼。',
          'zh-TW': '需要密码。',
        },
        '商品が見つかりません。': {
          'en': 'Product not found.',
          'ko': '상품을 찾을 수 없습니다.',
          'zh': '未找到產品。',
          'zh-TW': '未找到产品。',
        },
        'ログインが必要です。': {
          'en': 'Login is required.',
          'ko': '로그인이 필요합니다.',
          'zh': '需要登入。',
          'zh-TW': '需要登录。',
        },
        'パスワードが一致しません。': {
          'en': 'The passwords do not match.',
          'ko': '비밀번호가 일치하지 않습니다.',
          'zh': '密碼不符。',
          'zh-TW': '密码不匹配。',
        },
        'パスワードログを保存しました。': {
          'en': 'The password log has been saved.',
          'ko': '비밀번호 로그를 저장했습니다.',
          'zh': '密碼日誌已儲存。',
          'zh-TW': '密码日志已保存。',
        },
        '株式会社A': {
          'en': 'A Co., Ltd.',
          'ko': '주식회사 A',
          'zh': 'A 有限公司',
          'zh-TW': 'A 有限公司',
        },
        'Xmarket出品リスト': {
          'en': 'Xmarket listing list',
          'ko': 'Xmarket 출품 목록',
          'zh': 'Xmarket 列表',
          'zh-TW': 'Xmarket 列表',
        },
        '即決価格としてマーケットに出品': {
          'en': 'Listed on the market as a Buy It Now price',
          'ko': '즉결 가격으로 시장에 출품',
          'zh': '市面上標價為一價',
          'zh-TW': '市场上标价为一口价',
        },
        '販売価格を入力してください': {
          'en': 'Enter your sales price',
          'ko': '판매 가격을 입력하세요.',
          'zh': '請輸入您的銷售價格',
          'zh-TW': '请输入您的销售价格',
        },
        'オークションとしてこの価格からマーケットに出品': {
          'en': 'Auction on the market starting at this price',
          'ko': '경매로 이 가격에서 시장에 출품',
          'zh': '拍賣會以這個價格在市場上舉行。',
          'zh-TW': '拍卖会以这个价格在市场上举行。',
        },
        '%d秒': {
          'en': '%d seconds',
          'ko': '%d초',
          'zh': '%d 秒',
          'zh-TW': '%d 秒',
        },
        '%d分': {
          'en': '%d minutes',
          'ko': '%d분',
          'zh': '%d 分鐘',
          'zh-TW': '%d 分钟',
        },
        '%d時間': {
          'en': '%d hours',
          'ko': '%d시간',
          'zh': '%d 小時',
          'zh-TW': '%d 小时',
        },
        '金額は{min}円以上になるように設定してください': {
          'en': 'Please set the amount to be at least {min} yen',
          'ko': '금액은 {min}엔 이상이 되도록 설정하세요.',
          'zh': '請將金額設定為至少 {min} 日元',
          'zh-TW': '请将金额设置为至少 {min} 日元',
        },
        '小計': {
          'en': 'subtotal',
          'ko': '소계',
          'zh': '小計',
          'zh-TW': '小计',
        },
        '送料': {
          'en': 'postage',
          'ko': '우송료',
          'zh': '郵資',
          'zh-TW': '邮资',
        },
        '合計': {
          'en': 'total',
          'ko': '합계',
          'zh': '全部的',
          'zh-TW': '全部的',
        },
        'カート': {
          'en': 'cart',
          'ko': '장바구니',
          'zh': '大車',
          'zh-TW': '大车',
        },
        '金額': {
          'en': 'Amount',
          'ko': '금액',
          'zh': '數量',
          'zh-TW': '数量',
        },
        '数量': {
          'en': 'quantity',
          'ko': '수량',
          'zh': '數量',
          'zh-TW': '数量',
        },
        'カート商品が見つかりません': {
          'en': 'No items found in cart',
          'ko': '장바구니 상품을 찾을 수 없음',
          'zh': '購物車中未找到商品。購物車內沒有商品。',
          'zh-TW': '购物车中未找到商品。购物车内没有商品。',
        },
        '新たにカードを登録する': {
          'en': 'Register a new card',
          'ko': '새 카드 등록',
          'zh': '註冊新卡',
          'zh-TW': '注册新卡',
        },
        'カード情報の保存に失敗しました。(既に登録されているなど)': {
          'en': 'Failed to save card information (e.g., already registered).',
          'ko': '카드 정보를 저장하지 못했습니다. (이미 등록된 등)',
          'zh': '儲存卡片資訊失敗（例如，已註冊）。',
          'zh-TW': '保存卡片信息失败（例如，已注册）。',
        },
        'カード情報の削除に失敗しました。': {
          'en': 'Failed to delete card information.',
          'ko': '카드 정보를 삭제하지 못했습니다.',
          'zh': '刪除卡片資訊失敗。',
          'zh-TW': '删除卡片信息失败。',
        },
        'このカード情報を保存する': {
          'en': 'Save this card information',
          'ko': '이 카드 정보 저장',
          'zh': '儲存此卡片訊息',
          'zh-TW': '保存此卡片信息',
        },
        '出金申請': {
          'en': 'Withdrawal application',
          'ko': '출금 신청',
          'zh': '提款申請',
          'zh-TW': '提款申请',
        },
        '出金可能額': {
          'en': 'Amount that can be withdrawn',
          'ko': '출금 가능액',
          'zh': '可提取金額',
          'zh-TW': '可提取金额',
        },
        '振込金額': {
          'en': 'Transfer amount',
          'ko': '송금 금액',
          'zh': '轉帳金額',
          'zh-TW': '转账金额',
        },
        '振込方法': {
          'en': 'Transfer method',
          'ko': '송금 방법',
          'zh': '轉移方法',
          'zh-TW': '转移方法',
        },
        '振込額3万円未満は350円の振込手数料がかかります。': {
          'en': 'The receiving fee will be deducted from the sending amount.',
          'ko': '接收費用將從發送金額中扣除。',
          'zh': '接收费用将从发送金额中扣除。',
          'zh-TW': '接收费用将从发送金额中扣除。',
        },
        '振込申請日の5営業日後に送金させていただきます。': {
          'en': 'The funds will be transferred five business days after the transfer request date.',
          'ko': '송금 신청일의 5 영업일 후에 송금하겠습니다.',
          'zh': '款項將在轉帳申請日期後的五個工作天內轉入。',
          'zh-TW': '款项将在转账申请日期后的五个工作日内转入。',
        },
        '申請する': {
          'en': 'Apply',
          'ko': '신청하다',
          'zh': '申請',
          'zh-TW': '申请',
        },
        '出金申請履歴': {
          'en': 'Withdrawal request history',
          'ko': '출금 신청 이력',
          'zh': '提款申請歷史記錄',
          'zh-TW': '提款申请历史记录',
        },
        '申請日': {
          'en': 'Application date',
          'ko': '신청일',
          'zh': '申請日期',
          'zh-TW': '申请日期',
        },
        '振込日': {
          'en': 'Transfer date',
          'ko': '송금일',
          'zh': '轉會日期',
          'zh-TW': '转会日期',
        },
        '未振込': {
          'en': 'Unpaid',
          'ko': '미송금',
          'zh': '未付',
          'zh-TW': '未付',
        },
        '振込済': {
          'en': 'Transfer completed',
          'ko': '송금',
          'zh': '轉帳完成',
          'zh-TW': '转账完成',
        },
        '口座番号': {
          'en': 'Account number',
          'ko': '계좌 번호',
          'zh': '帳號',
          'zh-TW': '帐号',
        },
        '販売価格を決める': {
          'en': 'Decide on a selling price',
          'ko': '판매 가격 결정',
          'zh': '確定售價',
          'zh-TW': '确定售价',
        },
        '未出品': {
          'en': 'Not listed',
          'ko': '미출품',
          'zh': '未列出',
          'zh-TW': '未列出',
        },
        '出品待ち/出品中': {
          'en': 'Waiting for listing/On sale',
          'ko': '출품 대기/출품 중',
          'zh': '等待上架/已售',
          'zh-TW': '等待上架/已售',
        },
        '完売': {
          'en': 'sold out',
          'ko': '매진',
          'zh': '售罄',
          'zh-TW': '售罄',
        },
        '全タイトル': {
          'en': 'All titles',
          'ko': '모든 타이틀',
          'zh': '所有標題',
          'zh-TW': '所有标题',
        },
        '詳細検索': {
          'en': 'Advanced Search',
          'ko': '고급 검색',
          'zh': '進階搜尋',
          'zh-TW': '高级搜索',
        },
        '傷あり品を除く': {
          'en': 'Excluding damaged items',
          'ko': '긁힌 물건을 제외하다',
          'zh': '不包括損壞物品',
          'zh-TW': '不包括损坏物品',
        },
        '傷あり品のみ表示': {
          'en': 'Display only damaged items',
          'ko': '僅顯示損壞的物品',
          'zh': '仅显示损坏的物品',
          'zh-TW': '仅显示损坏的物品',
        },
        '表示順': {
          'en': 'Display order',
          'ko': '표시 순서',
          'zh': '顯示順序',
          'zh-TW': '显示顺序',
        },
        'キーワード検索': {
          'en': 'Keyword search',
          'ko': '키워드 검색',
          'zh': '關鍵字搜尋',
          'zh-TW': '关键词搜索',
        },
        '価格が高い順': {
          'en': 'Highest price first',
          'ko': '가격이 높은 순서',
          'zh': '價格最高者優先',
          'zh-TW': '价格最高者优先',
        },
        '価格が安い順': {
          'en': 'Lowest price first',
          'ko': '가격이 싼 순서',
          'zh': '價格最低者優先',
          'zh-TW': '价格最低者优先',
        },
        'クリア': {
          'en': 'Clear',
          'ko': '클리어',
          'zh': '清除',
          'zh-TW': '清除',
        },
        '検索': {
          'en': 'Search',
          'ko': '검색',
          'zh': '搜尋',
          'zh-TW': '搜索',
        },
        '販売中のみ表示': {
          'en': 'Show only items currently on sale',
          'ko': '판매 중에만 표시',
          'zh': '僅顯示當前促銷商品',
          'zh-TW': '仅显示当前促销商品',
        },
        'カートへ': {
          'en': 'Add to Cart',
          'ko': '장바구니에',
          'zh': '加入購物車',
          'zh-TW': '添加到购物车',
        },
        '終了': {
          'en': 'end',
          'ko': '종료',
          'zh': '結尾',
          'zh-TW': '结尾',
        },
        '現在': {
          'en': 'the current',
          'ko': '현재',
          'zh': '目前',
          'zh-TW': '当前',
        },
        '銀行振込': {
          'en': 'Bank transfer',
          'ko': '은행 송금',
          'zh': '銀行轉帳',
          'zh-TW': '银行转账',
        },
        '申請中': {
          'en': 'Currently applying',
          'ko': '신청 중',
          'zh': '目前正在申請',
          'zh-TW': '目前正在申请',
        },
        '保存する': {
          'en': 'Save',
          'ko': '저장하다',
          'zh': '節省',
          'zh-TW': '节省',
        },
        'スピード入金を利用する(翌営業日の送金)': {
          'en': 'Use express deposit (transfer on the next business day)',
          'ko': '스피드 입금을 이용한다(다음 영업일의 송금)',
          'zh': '使用快速存款（下一個工作日到帳）',
          'zh-TW': '使用快速存款（下一个工作日到账）',
        },
        '振込先情報': {
          'en': 'Bank transfer information',
          'ko': '송금처 정보',
          'zh': '銀行轉帳資訊',
          'zh-TW': '银行转账信息',
        },
        '削除': {
          'en': 'delete',
          'ko': '삭제',
          'zh': '刪除',
          'zh-TW': '删除',
        },
        '申請振込金額': {
          'en': 'Application transfer amount',
          'ko': '신청 송금 금액',
          'zh': '應用程式轉帳金額',
          'zh-TW': '应用程序转账金额',
        },
        '申請確認': {
          'en': 'Application confirmation',
          'ko': '신청 확인',
          'zh': '申請確認',
          'zh-TW': '申请确认',
        },
        '振込手数料': {
          'en': 'Bank transfer fee',
          'ko': '송금 수수료',
          'zh': '銀行轉帳手續費',
          'zh-TW': '银行转账手续费',
        },
        'ホビー': {
          'en': 'Hobby',
          'ko': '취미',
          'zh': '嗜好',
          'zh-TW': '爱好',
        },
        '選択してください': {
          'en': 'please select',
          'ko': '선택해주세요',
          'zh': '請選擇',
          'zh-TW': '请选择',
        },
        'Xmarketのご利用ありがとうございました': {
          'en': 'Thank you for using Xmarket',
          'ko': 'Xmarket를 이용해 주셔서 감사합니다.',
          'zh': '感謝您使用 Xmarket',
          'zh-TW': '感谢您使用 Xmarket',
        },
        '購入完了': {
          'en': 'Purchase complete',
          'ko': '구매 완료',
          'zh': '購買完成',
          'zh-TW': '购买完成',
        },
        '入金済み': {
          'en': 'Deposit completed',
          'ko': '입금됨',
          'zh': '存款已完成',
          'zh-TW': '存款已完成',
        },
        'マーケット履歴': {
          'en': 'Market History',
          'ko': '마켓 이력',
          'zh': '市場歷史',
          'zh-TW': '市场历史',
        },
        '申請履歴はありません': {
          'en': 'There is no application history',
          'ko': '신청 내역 없음',
          'zh': '沒有申請紀錄',
          'zh-TW': '没有申请记录',
        },
        '未入金': {
          'en': 'Unpaid',
          'ko': '미입금',
          'zh': '未付',
          'zh-TW': '未付',
        },
        '{min}円以上の価格で出品できます。当該ガチャの販売終了後に出品されます。': {
          'en': 'Items can be listed for a price of {min} yen or more. They will be listed after the sale of the gacha has ended.',
          'ko': '商品售價為 {min} 日圓或以上即可上架。商品將在扭蛋銷售結束後上架。',
          'zh': '商品售价为 {min} 日元或以上即可上架。商品将在扭蛋销售结束后上架。',
          'zh-TW': '商品售价为 {min} 日元或以上即可上架。商品将在扭蛋销售结束后上架。',
        },
        'パラメータが不足しています': {
          'en': 'Missing parameters',
          'ko': '매개변수가 부족함',
          'zh': '缺少參數',
          'zh-TW': '缺少参数',
        },
        '出品対象外品': {
          'en': 'Items not eligible for listing',
          'ko': '출품 대상 외품',
          'zh': '不符合上架條件的物品',
          'zh-TW': '不符合上架条件的物品',
        },
        '購入手続きへ': {
          'en': 'Proceed to checkout',
          'ko': '구매 절차로',
          'zh': '進行結算',
          'zh-TW': '进行结算',
        },
        '振込金額は351円以上で入力してください。': {
          'en': 'Please enter a transfer amount of 351 yen or more.',
          'ko': '송금 금액은 351엔 이상으로 입력해 주세요.',
          'zh': '請輸入351日圓或以上的轉帳金額。',
          'zh-TW': '请输入351日元或以上的转账金额。',
        },
        '振込金額は10,000円以上で入力してください。': {
          'en': 'Please enter a transfer amount of 10,000 yen or more.',
          'ko': '송금 금액은 10,000엔 이상으로 입력해 주세요.',
          'zh': '請輸入10000日圓或以上的轉帳金額。',
          'zh-TW': '请输入10000日元或以上的转账金额。',
        },
        '振込金額が出金可能額を超えています。': {
          'en': 'The transfer amount exceeds the available withdrawal amount.',
          'ko': '송금 금액이 출금 가능 금액을 초과합니다.',
          'zh': '轉帳金額超過了可用提款金額。',
          'zh-TW': '转账金额超过了可用提款金额。',
        },
        '〒330-0854 埼玉県さいたま市大宮区桜木町1丁目195‑1 大宮ソラミチKOZ4階': {
          'en': '4th floor, Omiya Soramichi KOZ, 1-195-1 Sakuragicho, Omiya-ku, Saitama City, Saitama Prefecture, 330-0854',
          'ko': '〒330-0854 사이타마현 사이타마시 오미야구 사쿠라기초 1가 195-1 오미야 소라미치 KOS4층',
          'zh': '郵編：330-0854 埼玉縣埼玉市大宮區櫻木町 1-195-1 大宮空道 KOZ 4 樓',
          'zh-TW': '邮编：330-0854 埼玉县埼玉市大宫区樱木町 1-195-1 大宫空道 KOZ 4 楼',
        },
        '発送先': {
          'en': 'Shipping address',
          'ko': '배송지',
          'zh': '收件地址',
          'zh-TW': '收件地址',
        },
        '査定額': {
          'en': 'Appraisal value',
          'ko': '평가 금액',
          'zh': '評估價值',
          'zh-TW': '评估价值',
        },
        '買取受付番号': {
          'en': 'Purchase receipt number',
          'ko': '구매 접수 번호',
          'zh': '購買收據編號',
          'zh-TW': '购买收据编号',
        },
        '査定枚数': {
          'en': 'Number of appraisals',
          'ko': '평가 매수',
          'zh': '評估次數',
          'zh-TW': '评估次数',
        },
        '減額枚数': {
          'en': 'Number of discounts',
          'ko': '감액 매수',
          'zh': '折扣數量',
          'zh-TW': '折扣数量',
        },
        '返送枚数': {
          'en': 'Number of returned items',
          'ko': '반송 매수',
          'zh': '退貨商品數量',
          'zh-TW': '退货商品数量',
        },
        '振込': {
          'en': 'transfer',
          'ko': '송금',
          'zh': '轉移',
          'zh-TW': '转移',
        },
        '【特価品】': {
          'en': '[Damaged item]',
          'ko': '【상처 있어 품】',
          'zh': '[物品損壞]',
          'zh-TW': '[物品损坏]',
        },
        '【取り下げ】': {
          'en': '[Withdrawn]',
          'ko': '【취하】',
          'zh': '【已撤回】',
          'zh-TW': '【已撤回】',
        },
        '買取申込(会員様限定)': {
          'en': 'Purchase application (members only)',
          'ko': '매입 신청 (회원님 한정)',
          'zh': '購買申請（僅限會員）',
          'zh-TW': '购买申请（仅限会员）',
        },
        '未出品の状態で24時間に販売価格を設定されていなければ、自動でコインへ還元されます。': {
          'en': 'If the item is unlisted and no selling price is set within 24 hours, it will be automatically converted into coins.',
          'ko': '미출품 상태에서 24시간에 판매가격이 설정되어 있지 않으면 자동으로 코인으로 환원됩니다.',
          'zh': '如果該物品未上架且在 24 小時內未設定售價，則將自動轉換為金幣。',
          'zh-TW': '如果该物品未上架且在 24 小时内未设定售价，则将自动转换为金币。',
        },
        'マーケットへ出品して2週間経過して売れなかった場合は、自動でコインへ還元されます。': {
          'en': 'If an item is not sold after two weeks of being listed on the market, it will be automatically converted into coins.',
          'ko': '마켓에 출품해 2주간 경과해 팔리지 않았던 경우는, 자동으로 코인에 환원됩니다.',
          'zh': '如果一件物品在市場上掛牌兩週後仍未售出，它將自動轉換為金幣。',
          'zh-TW': '如果一件物品在市场上挂牌两周后仍未售出，它将自动转换为金币。',
        },
        '出品開始後2週間以内なら、「コインへ還元」「発送依頼」を自由に変更できます。': {
          'en': 'You can freely change the option to "redeem coins" or "request shipping" within two weeks of starting the listing.',
          'ko': '출품 개시 후 2주일 이내라면, 「코인에 환원」 「발송 의뢰」를 자유롭게 변경할 수 있습니다.',
          'zh': '在商品上架後的兩週內，您可以隨時將選項變更為「兌換金幣」或「要求出貨」。',
          'zh-TW': '在商品上架后的两周内，您可以随时将选项更改为“兑换金币”或“请求发货”。',
        },
        '販売手数料として10%を頂戴いたします。': {
          'en': 'A 10% sales commission will be charged.',
          'ko': '판매 수수료로서 10%를 받습니다.',
          'zh': '將收取10%的銷售佣金。',
          'zh-TW': '将收取10%的销售佣金。',
        },
        '売上金についてはこちらをご確認ください。': {
          'en': 'Please click here for details on sales.',
          'ko': '매출금에 대해서는 이쪽을 확인해 주세요.',
          'zh': '請點擊此處查看銷售詳情。',
          'zh-TW': '请点击此处查看销售详情。',
        },
        '2タップで「X marketで販売」となります。': {
          'en': 'Two taps will make it "Sell on X market."',
          'ko': '2 탭으로 「X market에서 판매」가 됩니다.',
          'zh': '輕點兩下即可設定為「在 X 市場出售」。',
          'zh-TW': '轻点两下即可设置为“在 X 市场出售”。',
        },
        'コインに還元する': {
          'en': 'Redeem for coins',
          'ko': '동전으로 환원',
          'zh': '兌換金幣',
          'zh-TW': '兑换金币',
        },
        '発送する': {
          'en': 'Ship',
          'ko': '발송하다',
          'zh': '船',
          'zh-TW': '船',
        },
        'このカードをコインに還元しますか？': {
          'en': 'Would you like to redeem this card for coins?',
          'ko': '이 카드를 동전으로 환원하시겠습니까?',
          'zh': '您想用這張卡兌換金幣嗎？',
          'zh-TW': '您想用这张卡兑换金币吗？',
        },
        '(※実行後の変更はできません)': {
          'en': '(※Changes cannot be made after execution)',
          'ko': '(※실행 후의 변경은 할 수 없습니다)',
          'zh': '（※執行後無法更改）',
          'zh-TW': '（※执行后无法更改）',
        },
        'このカードを発送しますか？': {
          'en': 'Would you like to send this card?',
          'ko': '이 카드를 발송하시겠습니까?',
          'zh': '您想寄送這張賀卡嗎？',
          'zh-TW': '您想寄送这张贺卡吗？',
        },
        '当該ガチャの販売終了後に自動で出品されます': {
          'en': 'It will be automatically put up for sale after the sale of the gacha ends.',
          'ko': '해당 뽑기의 판매 종료 후 자동으로 출품됩니다',
          'zh': '扭蛋活動結束後，它將自動上架出售。',
          'zh-TW': '扭蛋活动结束后，它将自动上架出售。',
        },
        'マーケット購入': {
          'en': 'Market Purchase',
          'ko': '마켓 구매',
          'zh': '市場購買',
          'zh-TW': '市场购买',
        },
        'フィギュア': {
          'en': 'Figures',
          'ko': '피규어',
          'zh': '數據',
          'zh-TW': '数据',
        },
        '{min}円以上の価格で出品できます': {
          'en': 'You can sell it for more than {min} yen',
          'ko': '您可以以高於{min}日圓的價格出售它',
          'zh': '您可以以高于{min}日元的价格出售它',
          'zh-TW': '您可以以高于{min}日元的价格出售它',
        },
        'カートに追加しました': {
          'en': 'Added to Cart',
          'ko': '장바구니에 추가됨',
          'zh': '加入購物車',
          'zh-TW': '加入购物车',
        },
        'マーケット購入品': {
          'en': 'Market purchases',
          'ko': '마켓 구매품',
          'zh': '市場購買',
          'zh-TW': '市场购买',
        },
        '該当するカード履歴が見つかりません': {
          'en': 'No matching card history found',
          'ko': '해당 카드 기록을 찾을 수 없습니다.',
          'zh': '未找到符合的信用卡歷史記錄',
          'zh-TW': '未找到匹配的信用卡历史记录',
        },
        'このカードの所有者ではありません': {
          'en': 'I don\'t own this card',
          'ko': '이 카드의 소유자가 아닙니다.',
          'zh': '我沒有這張卡。',
          'zh-TW': '我没有这张卡。',
        },
        'このカードは既に取引が完了しています': {
          'en': 'This card has already been used for a transaction',
          'ko': '이 카드는 이미 거래가 완료되었습니다.',
          'zh': '這張卡已經用於交易過。',
          'zh-TW': '这张卡已经用于交易过。',
        },
        '出品できないカードです': {
          'en': 'This card cannot be sold',
          'ko': '전시 할 수없는 카드입니다.',
          'zh': '這張卡不能出售',
          'zh-TW': '这张卡不能出售',
        },
        '既に出品されています': {
          'en': 'Already listed',
          'ko': '이미 전시되었습니다.',
          'zh': '已列出',
          'zh-TW': '已列出',
        },
        '既にカートに追加されています': {
          'en': 'Already added to cart',
          'ko': '이미 장바구니에 추가되었습니다.',
          'zh': '已加入購物車',
          'zh-TW': '已加入购物车',
        },
        '自分の出品はカートに追加できません': {
          'en': 'You cannot add your own items to the cart',
          'ko': '자신의 전시는 장바구니에 추가할 수 없습니다.',
          'zh': '您不能將自己的商品加入購物車。',
          'zh-TW': '您不能将自己的商品添加到购物车。',
        },
        '出品が見つかりません': {
          'en': 'No listings found',
          'ko': '출품을 찾을 수 없음',
          'zh': '未找到任何房源。',
          'zh-TW': '未找到任何房源。',
        },
        'システムエラーが発生しました': {
          'en': 'A system error has occurred',
          'ko': '시스템 오류가 발생했습니다.',
          'zh': '系統發生錯誤',
          'zh-TW': '系统发生错误',
        },
        '既に購入済みです': {
          'en': 'Already purchased',
          'ko': '이미 구입했습니다.',
          'zh': '已購買',
          'zh-TW': '已购买',
        },
        '既に他の人に購入されました': {
          'en': 'Already purchased by someone else',
          'ko': '이미 다른 사람들에게 구입했습니다.',
          'zh': '已被他人購買',
          'zh-TW': '已被他人购买',
        },
        '自分の出品は購入できません': {
          'en': 'You can\'t buy your own listings',
          'ko': '자신의 출품은 구입할 수 없습니다.',
          'zh': '你不能購買自己的房源信息',
          'zh-TW': '你不能购买自己的房源信息',
        },
        'オークション商品は個別に購入してください': {
          'en': 'Auction items must be purchased individually',
          'ko': '경매 상품은 개별적으로 구입해 주세요',
          'zh': '拍賣品必須單獨購買。',
          'zh-TW': '拍卖品必须单独购买。',
        },
        '商品価格が変更されました': {
          'en': 'The product price has changed',
          'ko': '상품 가격이 변경되었습니다.',
          'zh': '產品價格已變更',
          'zh-TW': '产品价格已变更',
        },
        '商品が見つかりません': {
          'en': 'Product not found',
          'ko': '상품을 찾을 수 없음',
          'zh': '未找到產品',
          'zh-TW': '未找到产品',
        },
        'サポートされていない決済方法です': {
          'en': 'Unsupported payment method',
          'ko': '지원되지 않는 결제 방법입니다.',
          'zh': '不支援的支付方式',
          'zh-TW': '不支持的支付方式',
        },
        '決済処理でエラーが発生しました': {
          'en': 'An error occurred during payment processing',
          'ko': '결제 처리 중 오류가 발생했습니다.',
          'zh': '支付處理過程中發生錯誤',
          'zh-TW': '支付处理过程中发生错误',
        },
        '購入完了処理に失敗しました': {
          'en': 'Purchase completion failed',
          'ko': '구매 완료 처리에 실패했습니다.',
          'zh': '購買完成失敗',
          'zh-TW': '购买完成失败',
        },
        '一部の商品が購入できませんでした': {
          'en': 'Some items could not be purchased',
          'ko': '일부 상품을 구입할 수 없습니다.',
          'zh': '部分商品無法購買。',
          'zh-TW': '部分商品无法购买。',
        },
        'カートに商品がありません': {
          'en': 'No items in cart',
          'ko': '장바구니에 상품이 없습니다.',
          'zh': '購物車內沒有商品',
          'zh-TW': '购物车内没有商品',
        },
        '購入情報が見つかりません': {
          'en': 'No purchase information found',
          'ko': '구매 정보를 찾을 수 없음',
          'zh': '未找到購買訊息',
          'zh-TW': '未找到购买信息',
        },
        '購入が完了しました': {
          'en': 'Your purchase is complete',
          'ko': '구매가 완료되었습니다.',
          'zh': '您的購買已完成',
          'zh-TW': '您的购买已完成',
        },
        '購入処理でエラーが発生しました': {
          'en': 'An error occurred during the purchase process',
          'ko': '구매 처리 중 오류가 발생했습니다.',
          'zh': '購買過程中出現錯誤',
          'zh-TW': '购买过程中出现错误',
        },
        '入金情報が見つかりません': {
          'en': 'No deposit information found',
          'ko': '입금 정보를 찾을 수 없음',
          'zh': '未找到存款資訊',
          'zh-TW': '未找到存款信息',
        },
        '振込金額は手数料を差し引いた金額が1円以上になるように指定してください': {
          'en': 'Please specify the transfer amount so that the total amount after deducting the fee is 1 yen or more.',
          'ko': '송금 금액은 수수료를 뺀 금액이 1 엔 이상이되도록 지정하십시오',
          'zh': '請指定轉帳金額，使扣除手續費後的總金額為1日圓或以上。',
          'zh-TW': '请指定转账金额，使扣除手续费后的总金额为1日元或以上。',
        },
        '不正な振込タイプです': {
          'en': 'Invalid transfer type',
          'ko': '부정한 송금 타입입니다',
          'zh': '無效的轉帳類型',
          'zh-TW': '无效的转账类型',
        },
        '出金可能額を超えています': {
          'en': 'The withdrawal limit has been exceeded',
          'ko': '출금 가능 금액을 초과했습니다.',
          'zh': '提款限額已超出',
          'zh-TW': '提款限额已超出',
        },
        '銀行口座情報が不足しています': {
          'en': 'Missing bank account information',
          'ko': '은행 계좌 정보가 부족합니다.',
          'zh': '缺少銀行帳戶信息',
          'zh-TW': '缺少银行账户信息',
        },
        'PayPalメールアドレスが不足しています': {
          'en': 'Missing PayPal email address',
          'ko': 'PayPal 이메일 주소가 부족합니다.',
          'zh': '缺少 PayPal 電子郵件地址',
          'zh-TW': '缺少 PayPal 电子邮件地址',
        },
        '不正な入金情報の種別です': {
          'en': 'Invalid deposit information type',
          'ko': '무단 입금 정보의 종류입니다.',
          'zh': '無效的存款資訊類型',
          'zh-TW': '无效的存款信息类型',
        },
        'マーケットIDまたはユーザー履歴カードIDが必要です': {
          'en': 'Market ID or User History Card ID is required',
          'ko': '마켓 ID 또는 사용자 기록 카드 ID 필요',
          'zh': '需要提供市場 ID 或用戶歷史記錄卡 ID。',
          'zh-TW': '需要提供市场 ID 或用户历史记录卡 ID。',
        },
        '該当するマーケット出品が見つかりません': {
          'en': 'No matching market listings found',
          'ko': '해당 시장 출품을 찾을 수 없습니다.',
          'zh': '未找到匹配的市場列表',
          'zh-TW': '未找到匹配的市场列表',
        },
        'ログインが必要です': {
          'en': 'Login required',
          'ko': '로그인 필요',
          'zh': '需要登入',
          'zh-TW': '需要登录',
        },
        'PayPalの手数料に準ずる': {
          'en': 'In accordance with PayPal terms',
          'ko': 'PayPal 수수료에 부합',
          'zh': '根據PayPal費用',
          'zh-TW': '根据PayPal费用',
        },
        'PayPalの手数料が差し引かれた後の金額': {
          'en': 'Amount after PayPal fees have been deducted',
          'ko': 'PayPal 수수료가 공제된 후 금액',
          'zh': '扣除PayPal手續費後的金額',
          'zh-TW': '扣除PayPal手续费后的金额',
        },
        'PayPalメールアドレス': {
          'en': 'PayPal email address',
          'ko': 'PayPal 이메일 주소',
          'zh': 'PayPal 電子郵件地址',
          'zh-TW': 'PayPal 电子邮件地址',
        },
        'このカードを削除しますか？': {
          'en': 'Do you want to delete this card?',
          'ko': '이 카드를 삭제하시겠습니까?',
          'zh': '您要刪除這張卡嗎？',
          'zh-TW': '您要删除这张卡吗？',
        },
        '販売手数料として10%を頂戴いたします': {
          'en': 'We will charge a 10% sales commission',
          'ko': '판매 수수료로서 10%를 받습니다',
          'zh': '我們將收取10%的銷售佣金。',
          'zh-TW': '我们将收取10%的销售佣金。',
        },
        '未発送': {
          'en': 'Unshipped',
          'ko': '미발송',
          'zh': '未出貨',
          'zh-TW': '未发货',
        },
        '出品額': {
          'en': 'Exhibition amount',
          'ko': '출품액',
          'zh': '展覽金額',
          'zh-TW': '展览金额',
        },
        '入金額': {
          'en': 'Deposit amount',
          'ko': '입금액',
          'zh': '存款金額',
          'zh-TW': '存款金额',
        },
        'ポイント購入履歴': {
          'en': 'Point purchase history',
          'ko': '포인트 구매 내역',
          'zh': '購買歷史',
          'zh-TW': '购买历史',
        },
        '所持{amount}ポイント以下の方限定': {
          'en': 'Limited to those with less than {amount} points',
          'ko': '소지 {amount}포인트 이하의 분 한정',
          'zh': '僅限積分低於 {amount} 分的用戶',
          'zh-TW': '仅限积分低于 {amount} 分的用户',
        },
        '今月{amount}ポイント以上決済された方限定': {
          'en': 'Only available to those who have paid more than {amount} points this month',
          'ko': '이번 달 {amount}포인트 이상 결제된 분 한정',
          'zh': '僅限本月消費超過 {amount} 積分的用戶',
          'zh-TW': '仅限本月消费超过 {amount} 积分的用户',
        },
        '所持ポイント': {
          'en': 'Possession points',
          'ko': '소지 포인트',
          'zh': '控球點',
          'zh-TW': '控球点',
        },
        'ポイントを使用しない場合、来月は「{rank}」ランクになります。': {
          'en': 'If you don\'t use your points, you will be ranked "{rank}" next month.',
          'ko': '포인트를 사용하지 않으면 다음 달은 \'{rank}\' 순위가 됩니다.',
          'zh': '如果您不使用積分，下個月您的排名將為「{rank}」。',
          'zh-TW': '如果您不使用积分，下个月您的排名将为“{rank}”。',
        },
        '来月、「{rank}」からスタートするには {amount} ポイントが必要です。': {
          'en': 'You need {amount} points to start at "{rank}" next month.',
          'ko': '다음 달 "{rank}"에서 시작하려면 {amount} 포인트가 필요합니다.',
          'zh': '下個月你需要{amount}積分才能從「{rank}」等級開始。',
          'zh-TW': '下个月你需要{amount}积分才能从“{rank}”级别开始。',
        },
        'ポイントが不足しています': {
          'en': 'Not enough points',
          'ko': '포인트가 부족함',
          'zh': '積分不足',
          'zh-TW': '积分不足',
        },
        'ポイントのみ': {
          'en': 'Points only',
          'ko': '포인트만',
          'zh': '僅積分',
          'zh-TW': '仅积分',
        },
        'あなたも友達も 500ポイントがもらえる': {
          'en': 'You and your friend will receive 500 points',
          'ko': '당신도 친구도 500포인트를 받을 수 있다',
          'zh': '你和你的朋友將獲得 500 積分',
          'zh-TW': '你和你的朋友将获得 500 积分',
        },
        'ポイントの購入': {
          'en': 'Buying Points',
          'ko': '포인트 구매',
          'zh': '購買重點',
          'zh-TW': '购买要点',
        },
        'ポイントへの還元数': {
          'en': 'Number of points redeemed',
          'ko': '포인트로의 환원수',
          'zh': '已兌換積分數量',
          'zh-TW': '已兑换积分数量',
        },
        'ポイントへの合計還元数': {
          'en': 'Total points redeemed',
          'ko': '포인트에 대한 총 환원 수',
          'zh': '已兌換積分總數',
          'zh-TW': '已兑换积分总数',
        },
        'ポイント数': {
          'en': 'Number of points',
          'ko': '포인트 수',
          'zh': '分數',
          'zh-TW': '分数',
        },
        '引換履歴&ポイント履歴': {
          'en': 'Redemption history & points history',
          'ko': '교환 이력 & 포인트 이력',
          'zh': '兌換歷史與積分歷史',
          'zh-TW': '兑换历史和积分历史',
        },
        '引換・付与ポイント': {
          'en': 'Redemption and points awarded',
          'ko': '교환·부여 포인트',
          'zh': '兌換及積分獎勵',
          'zh-TW': '兑换及积分奖励',
        },
        '引換履歴&ポイント履歴がありません。': {
          'en': 'There is no redemption history or points history.',
          'ko': '교환 이력 & 포인트 이력이 없습니다.',
          'zh': '沒有兌換記錄或積分記錄。',
          'zh-TW': '没有兑换记录或积分记录。',
        },
        'ポイント購入完了': {
          'en': 'Points purchase completed',
          'ko': '포인트 구매 완료',
          'zh': '積分購買完成',
          'zh-TW': '积分购买完成',
        },
        'ポイントのご購入ありがとうございました。': {
          'en': 'Thank you for purchasing points.',
          'ko': '포인트를 구입해 주셔서 감사합니다.',
          'zh': '感謝您購買積分。',
          'zh-TW': '感谢您购买积分。',
        },
        'ポイント購入': {
          'en': 'Purchase Points',
          'ko': '포인트 구매',
          'zh': '購買積分',
          'zh-TW': '购买积分',
        },
        '購入ポイント': {
          'en': 'Purchase Points',
          'ko': '구매 포인트',
          'zh': '購買積分',
          'zh-TW': '购买积分',
        },
        'ポイントを': {
          'en': 'Points',
          'ko': '포인트를',
          'zh': '積分',
          'zh-TW': '积分',
        },
        '未選択のお品物は24時間でポイントへ自動変換されます': {
          'en': 'Unselected items will be automatically converted to points within 24 hours.',
          'ko': '선택되지 않은 제품은 24시간 내에 포인트로 자동 변환됩니다.',
          'zh': '未選擇的商品將在24小時內自動轉換為積分。',
          'zh-TW': '未选择的商品将在24小时内自动转换为积分。',
        },
        '発送は還元ポイントの合計が1,000P以上からとなります。': {
          'en': 'Shipping will be available for orders with a total of 1,000 points or more.',
          'ko': '발송은 환원 포인트의 합계가 1,000 P이상이 됩니다.',
          'zh': '訂單總額達到1000點或以上即可享有包郵服務。',
          'zh-TW': '订单总额达到1000积分或以上即可享受包邮服务。',
        },
        '還元ポイント（発送待ち商品）の合計が1,000P未満の場合は、1,000Pを超えてからの発送となります。': {
          'en': 'If the total number of points redeemed (items awaiting shipping) is less than 1,000 points, the items will be shipped once they exceed 1,000 points.',
          'ko': '환원 포인트(발송 대기 상품)의 합계가 1,000 P미만의 경우는, 1,000 P를 넘고 나서의 발송이 됩니다.',
          'zh': '如果兌換的積分總數（待出貨商品）少於 1,000 積分，則商品將在積分超過 1,000 積分後出貨。',
          'zh-TW': '如果兑换的积分总数（待发货商品）少于 1,000 积分，则商品将在积分超过 1,000 积分后发货。',
        },
        '株式会社はっち': {
          'en': 'Hatchi Co., Ltd.',
          'ko': '주식회사 하치',
          'zh': '哈奇有限公司',
          'zh-TW': '哈奇有限公司',
        },
        '大阪府大阪市平野区長吉出戸七丁目3-39': {
          'en': '3-39 Nagayoshi Deto 7-chome, Hirano-ku, Osaka City, Osaka Prefecture',
          'ko': '오사카부 오사카시 히라노구 나가요시 데이치 7초메 3-39',
          'zh': '大阪府大阪市平野區長吉德東7丁目3-39',
          'zh-TW': '大阪府大阪市平野区长吉德东7丁目3-39',
        },
        '〒547-0011': {
          'en': '〒547-0011',
          'ko': '〒547-0011',
          'zh': '〒547-0011',
          'zh-TW': '〒547-0011',
        },
        'TEL：06-6643-9996': {
          'en': 'TEL: 06-6643-9996',
          'ko': 'TEL:06-6643-9996',
          'zh': '電話：06-6643-9996',
          'zh-TW': '电话：06-6643-9996',
        },
        'ドラゴンボール': {
          'en': 'Dragon Ball',
          'ko': '드래곤볼',
          'zh': '七龍珠',
          'zh-TW': '龙珠',
        },
        'デュエルマスターズ': {
          'en': 'Duel Masters',
          'ko': '',
          'zh': '',
          'zh-TW': '',
        },
        'アーセナルベース': {
          'en': 'Arsenal Base',
          'ko': '',
          'zh': '',
          'zh-TW': '',
        },
        'ホロライブ': {
          'en': 'Hololive',
          'ko': '',
          'zh': '',
          'zh-TW': '',
        },
        '八塚 健': {
          'en': 'Ken Yatsuka',
          'ko': '하치즈카 켄',
          'zh': '八塚健',
          'zh-TW': '八冢健',
        },
        'デジタルコンテンツ': {
          'en': 'Digital Content',
          'ko': '',
          'zh': '',
          'zh-TW': '',
        },
        'ボーナス': {
          'en': 'bonus',
          'ko': '보너스',
          'zh': '獎金',
          'zh-TW': '奖金',
        },
        'SMS認証完了後、マイページに表示される「紹介コード」をご友人に会員登録時に入力してもらってください。\nそのご友人が「SMS認証」と「コイン購入」で、あなたとご友人の双方にコインが入ります。\n※双方が貰えるコイン数はこちらからご確認ください。': {
          'en': 'After SMS authentication is completed, please have your friend enter the "referral code" displayed on your My Page during their membership registration. \nWhen that friend completes "SMS authentication" and "coin purchase," both you and your friend will receive coins. \n*Please check here for the number of coins both parties can receive.',
          'ko': 'Dopo aver completato l\'autenticazione SMS, chiedi al tuo amico di inserire il "codice di riferimento" visualizzato sulla tua pagina personale durante la registrazione al loro abbonamento. Quando quell\'amico completa l\'"autenticazione SMS" e l\'"acquisto di monete", sia tu che il tuo amico riceverete monete. *Controlla qui per il numero di monete che entrambe le parti possono ricevere.',
          'zh': 'Nachdem die SMS-Authentifizierung abgeschlossen ist, lassen Sie bitte Ihren Freund den "Empfehlungscode" eingeben, der auf Ihrer Mein-Seite während seiner Mitgliedsregistrierung angezeigt wird. Wenn dieser Freund die "SMS-Authentifizierung" und den "Münzkauf" abschließt, erhalten sowohl Sie als auch Ihr Freund Münzen. *Bitte überprüfen Sie hier die Anzahl der Münzen, die beide Parteien erhalten können.',
          'zh-TW': 'Después de completar la autenticación por SMS, por favor pide a tu amigo que ingrese el "código de referencia" que se muestra en tu Mi Página durante su registro de membresía. Cuando ese amigo complete la "autenticación por SMS" y la "compra de monedas", tanto tú como tu amigo recibirán monedas. *Por favor, consulta aquí para conocer el número de monedas que ambas partes pueden recibir.',
        },
        'シルバー会員以上の方はマイページの専用ボタンでコインを消費することにより、1つ下のランクから翌月はスタートすることが可能です。\n※ブロンズランクは3ヶ月間ブロンズが維持されます。\n詳細はこちらからご確認ください。': {
          'en': 'Silver members and above can start from one rank lower the following month by consuming coins with the dedicated button on My Page. \n*Bronze rank is maintained for three months. Please check the details here.',
          'ko': 'I membri Silver e superiori possono iniziare da un grado inferiore il mese successivo consumando monete con il pulsante dedicato nella Mia Pagina. *Il grado Bronze è mantenuto per tre mesi. Si prega di controllare i dettagli qui.',
          'zh': 'Silbermitglieder und höher können im folgenden Monat eine Stufe niedriger beginnen, indem sie Münzen mit der speziellen Schaltfläche auf Meine Seite verwenden. *Bronze-Rang wird für drei Monate beibehalten. Bitte überprüfen Sie die Details hier.',
          'zh-TW': 'Los miembros de plata y superiores pueden comenzar desde un rango inferior el mes siguiente consumiendo monedas con el botón dedicado en Mi Página. *El rango de bronce se mantiene durante tres meses. Por favor, consulte los detalles aquí.',
        },
        'ご検討ありがとうございます。まずはこちらよりお問合せをお願いいたします。': {
          'en': 'Thank you for your consideration. Please contact us from here first.',
          'ko': 'Grazie per la vostra considerazione. Vi preghiamo di contattarci prima da qui.',
          'zh': 'Vielen Dank für Ihre Berücksichtigung. Bitte kontaktieren Sie uns zuerst hier.',
          'zh-TW': 'Gracias por su consideración. Por favor, contáctenos desde aquí primero.',
        },
        '原則2営業日以内にお返事いたします。': {
          'en': 'We will reply within 2 business days in principle.',
          'ko': 'Risponderemo entro 2 giorni lavorativi in linea di principio.',
          'zh': 'Wir werden grundsätzlich innerhalb von 2 Werktagen antworten.',
          'zh-TW': 'Responderemos en un plazo de 2 días hábiles en principio.',
        },
        '動画を離脱することなく、最後までご視聴ください。\nそれでも反映されない場合は恐れ入りますがお問い合わせくださいませ。': {
          'en': 'Please watch the video until the end without leaving. If it still doesn\'t reflect, we apologize, but please contact us.',
          'ko': 'Si prega di guardare il video fino alla fine senza uscire. Se ancora non si riflette, ci scusiamo, ma vi preghiamo di contattarci.',
          'zh': 'Bitte sehen Sie sich das Video bis zum Ende an, ohne es zu verlassen. Wenn es immer noch nicht angezeigt wird, entschuldigen wir uns, aber bitte kontaktieren Sie uns.',
          'zh-TW': 'Por favor, mira el video hasta el final sin salir. Si aún no se refleja, nos disculpamos, pero por favor contáctanos.',
        },
        '発送は、毎月5日・10日・15日・20日・25日・月末におこなわせていただきます。': {
          'en': 'Shipments are generally made around the 10th, 20th, and 30th of each month.\n*The monthly shipping schedule will be posted on the website each month.\n*Shipments may be delayed at our discretion if the number of items to ship is low. If you have any concerns, please feel free to contact us.',
          'ko': 'Le spedizioni vengono generalmente effettuate intorno al 10, 20 e 30 di ogni mese. *Il programma di spedizione mensile sarà pubblicato sul sito web ogni mese. *Le spedizioni possono essere ritardate a nostra discrezione se il numero di articoli da spedire è basso. Se hai qualche preoccupazione, non esitare a contattarci.',
          'zh': 'Sendungen erfolgen in der Regel um den 10., 20. und 30. eines jeden Monats. *Der monatliche Versandplan wird jeden Monat auf der Website veröffentlicht. *Sendungen können nach unserem Ermessen verzögert werden, wenn die Anzahl der zu versendenden Artikel gering ist. Wenn Sie Bedenken haben, können Sie uns gerne kontaktieren.',
          'zh-TW': 'Los envíos generalmente se realizan alrededor del 10, 20 y 30 de cada mes. *El calendario de envíos mensuales se publicará en el sitio web cada mes. *Los envíos pueden retrasarse a nuestra discreción si la cantidad de artículos a enviar es baja. Si tiene alguna inquietud, no dude en contactarnos.',
        },
        '配送過程で傷が付かないよう丁寧に梱包することを心掛けます。\nもし、ご希望やご要望等がございましたらご遠慮なく本サイトのチャットよりお申し付けくださいませ。': {
          'en': 'We take care to pack items carefully to prevent damage during shipping.\nIf you have any requests or preferences, please feel free to let us know via the chat on this site or WhatsApp.',
          'ko': 'Ci prendiamo cura di imballare gli articoli con attenzione per prevenire danni durante la spedizione. Se hai richieste o preferenze, non esitare a farcelo sapere tramite la chat su questo sito o WhatsApp.',
          'zh': 'Wir achten darauf, die Artikel sorgfältig zu verpacken, um Schäden während des Versands zu vermeiden. Wenn Sie Wünsche oder Vorlieben haben, lassen Sie es uns bitte über den Chat auf dieser Seite oder WhatsApp wissen.',
          'zh-TW': 'Nos encargamos de embalar los artículos cuidadosamente para evitar daños durante el envío. Si tiene alguna solicitud o preferencia, no dude en hacérnoslo saber a través del chat en este sitio o por WhatsApp.',
        },
        'ヤマト運輸にて発送いたします。': {
          'en': 'We will ship via the post office, FedEx, or other carriers designated by our company.',
          'ko': 'Spediremo tramite l\'ufficio postale, FedEx o altri corrieri designati dalla nostra azienda.',
          'zh': 'Wir versenden über die Post, FedEx oder andere von unserem Unternehmen benannte Spediteure.',
          'zh-TW': 'Enviaremos a través de la oficina de correos, FedEx u otros transportistas designados por nuestra empresa.',
        },
        '送料は弊社が全額負担で元払いで発送いたします。': {
          'en': 'We will pay all shipping costs and ship the item prepaid. However, customs duties will be borne by the customer.',
          'ko': 'Coprireremo tutti i costi di spedizione e spediremo l\'articolo in porto franco. Tuttavia, i dazi doganali saranno a carico del cliente.',
          'zh': 'Wir übernehmen alle Versandkosten und versenden den Artikel frachtfrei. Allerdings werden die Zollgebühren vom Kunden getragen.',
          'zh-TW': 'Nosotros pagaremos todos los costos de envío y enviaremos el artículo prepagado. Sin embargo, los derechos de aduana serán asumidos por el cliente.',
        },
        'こちらよりご確認をお願いいたします。': {
          'en': 'Please check here.',
          'ko': 'Si prega di controllare qui.',
          'zh': 'Bitte hier überprüfen.',
          'zh-TW': 'Por favor, verifica aquí.',
        },
        '発送通知日と実際の発送日は配送業務の関係上異なってしまうことがございます。\nそのため、毎月5日・10日・15日・20日・25日・月末の夕方以降にご確認をお願いいたします。': {
          'en': 'Due to shipping operations, the date of the shipping notification and the actual shipping date may differ.\nTherefore, the tracking number may appear on the next business day after the shipping notification. We kindly ask for your understanding in advance.',
          'ko': 'A causa delle operazioni di spedizione, la data della notifica di spedizione e la data effettiva di spedizione possono differire. Pertanto, il numero di tracciamento potrebbe apparire il giorno lavorativo successivo alla notifica di spedizione. Vi chiediamo gentilmente di comprendere in anticipo.',
          'zh': 'Aufgrund von Versandvorgängen können das Datum der Versandbenachrichtigung und das tatsächliche Versanddatum abweichen. Daher kann die Sendungsnummer am nächsten Werktag nach der Versandbenachrichtigung erscheinen. Wir bitten im Voraus um Ihr Verständnis.',
          'zh-TW': 'Debido a las operaciones de envío, la fecha de la notificación de envío y la fecha real de envío pueden diferir. Por lo tanto, el número de seguimiento puede aparecer el siguiente día hábil después de la notificación de envío. Le pedimos amablemente su comprensión de antemano.',
        },
        'こちらからお問い合わせください。弊社側で変更いたします。': {
          'en': 'Please contact us via WhatsApp or the website chat.\nWhatsApp is here.',
          'ko': 'Si prega di contattarci tramite WhatsApp o la chat del sito web. WhatsApp è qui.',
          'zh': 'Bitte kontaktieren Sie uns über WhatsApp oder den Website-Chat. WhatsApp ist hier.',
          'zh-TW': 'Por favor, contáctenos a través de WhatsApp o el chat del sitio web. WhatsApp está aquí.',
        },
        '一律「中古品(二次流通品)・傷あり品」というご認識でお願いいたします。\nご留意事項等はこちらよりご確認をお願いいたします。': {
          'en': 'Please understand that all items are second-hand (secondary circulation) and damaged.\nPlease check here for important points to note.',
          'ko': 'Si prega di capire che tutti gli articoli sono di seconda mano (circolazione secondaria) e danneggiati. Si prega di controllare qui per i punti importanti da notare.',
          'zh': 'Bitte beachten Sie, dass alle Artikel gebraucht (sekundäre Zirkulation) und beschädigt sind. Bitte überprüfen Sie hier wichtige Punkte, die zu beachten sind.',
          'zh-TW': 'Por favor, comprenda que todos los artículos son de segunda mano (circulación secundaria) y están dañados. Por favor, consulte aquí los puntos importantes a tener en cuenta.',
        },
        '弊社で保管しているデータと確認させていただきます。\n恐れ入りますが、こちらよりお問い合わせくださいませ。': {
          'en': 'We will verify the data stored in our company.\nWe apologize for the inconvenience, but please contact us via the chat on this site or WhatsApp.\nWhatsApp is here',
          'ko': 'Verificheremo i dati memorizzati nella nostra azienda. Ci scusiamo per l\'inconveniente, ma contattaci tramite la chat su questo sito o WhatsApp. WhatsApp è qui.',
          'zh': 'Wir werden die in unserem Unternehmen gespeicherten Daten überprüfen. Wir entschuldigen uns für die Unannehmlichkeiten, aber bitte kontaktieren Sie uns über den Chat auf dieser Seite oder WhatsApp. WhatsApp ist hier.',
          'zh-TW': 'Verificaremos los datos almacenados en nuestra empresa. Pedimos disculpas por las molestias, pero por favor contáctenos a través del chat en este sitio o por WhatsApp. WhatsApp está aquí.',
        },
        '出品は、ブロンズ会員以上の方のみとなります。\nまた、当該ガチャの1回あたりの販売コイン数を上回る還元コイン数以上のお品物しか出品できません。': {
          'en': 'Only Bronze members and above can list items.\nFurthermore, you can only list items with a number of reward coins that exceeds the number of coins sold per pull of the gacha in question.',
          'ko': 'Solo i membri Bronze e superiori possono elencare articoli. Inoltre, puoi elencare articoli solo con un numero di monete premio che supera il numero di monete vendute per ogni estrazione del gacha in questione.',
          'zh': 'Nur Bronze-Mitglieder und höher können Artikel auflisten. Außerdem können Sie nur Artikel mit einer Anzahl von Belohnungsmünzen auflisten, die die Anzahl der pro Zug des betreffenden Gacha verkauften Münzen übersteigt.',
          'zh-TW': 'Solo los miembros de Bronce y superiores pueden listar artículos. Además, solo puedes listar artículos con un número de monedas de recompensa que exceda el número de monedas vendidas por tirada del gacha en cuestión.',
        },
        'ログイン画面よりパスワード再発行をクリックして、仮パスワードでログインしてください。\nその後、マイページよりパスワードをご変更ください。': {
          'en': 'Please click "Reissue password" on the login screen and log in with your temporary password.\nThen, please change your password from My Page.',
          'ko': 'Fare clic su "Riemetti password" nella schermata di accesso e accedi con la tua password temporanea. Quindi, cambia la tua password dalla Mia Pagina.',
          'zh': 'Bitte klicken Sie auf "Passwort neu ausstellen" auf dem Anmeldebildschirm und melden Sie sich mit Ihrem temporären Passwort an. Dann ändern Sie bitte Ihr Passwort auf Meine Seite.',
          'zh-TW': 'Por favor, haz clic en "Reemitir contraseña" en la pantalla de inicio de sesión e inicia sesión con tu contraseña temporal. Luego, por favor cambia tu contraseña desde Mi Página.',
        },
        '恐れ入りますが、こちらよりその旨のご連絡をお願いいたします。': {
          'en': 'We apologize for the inconvenience, but please contact us via this site\'s chat or WhatsApp to inform us of this matter.\nWhatsApp is here',
          'ko': 'Ci scusiamo per l\'inconveniente, ma ti preghiamo di contattarci tramite la chat di questo sito o WhatsApp per informarci di questa questione. WhatsApp è qui.',
          'zh': 'Wir entschuldigen uns für die Unannehmlichkeiten, aber bitte kontaktieren Sie uns über den Chat dieser Seite oder WhatsApp, um uns über diese Angelegenheit zu informieren. WhatsApp ist hier.',
          'zh-TW': 'Lamentamos las molestias, pero por favor contáctenos a través del chat de este sitio o WhatsApp para informarnos sobre este asunto. WhatsApp está aquí.',
        },
        '複数アカウントの所持は禁止しております。\n発覚した際は、告知なくアカウント制限の対象となりますので、ご留意くださいませ。': {
          'en': 'The possession of multiple accounts is prohibited. If discovered, the account will be subject to restrictions without notice, so please be aware.',
          'ko': 'Il possesso di più account è vietato. Se scoperto, l\'account sarà soggetto a restrizioni senza preavviso, quindi si prega di esserne consapevoli.',
          'zh': 'Der Besitz mehrerer Konten ist verboten. Wenn dies entdeckt wird, unterliegt das Konto ohne Vorankündigung Einschränkungen, also bitte beachten.',
          'zh-TW': 'La posesión de múltiples cuentas está prohibida. Si se descubre, la cuenta estará sujeta a restricciones sin previo aviso, así que por favor tenga en cuenta.',
        },
        '可能です。\n※1台で複数アカウントの利用はアカウント制限の対象にもなり得ますためお控えくださいませ。': {
          'en': 'It is possible. *Please refrain from using multiple accounts on one device as it may be subject to account restrictions.',
          'ko': 'È possibile. *Si prega di astenersi dall\'utilizzare più account su un dispositivo poiché potrebbe essere soggetto a restrizioni dell\'account.',
          'zh': 'Es ist möglich. *Bitte verzichten Sie darauf, mehrere Konten auf einem Gerät zu verwenden, da dies zu Kontobeschränkungen führen kann.',
          'zh-TW': 'Es posible. *Por favor, abstente de usar múltiples cuentas en un solo dispositivo, ya que puede estar sujeto a restricciones de cuenta.',
        },
        '弊社に到着後、原則2営業日には査定結果をお送りいたします。': {
          'en': 'We will send you the appraisal results in principle within two business days after arrival at our company.',
          'ko': 'Ti invieremo i risultati della valutazione in linea di principio entro due giorni lavorativi dall\'arrivo presso la nostra azienda.',
          'zh': 'Wir werden Ihnen die Bewertungsergebnisse grundsätzlich innerhalb von zwei Werktagen nach Eingang in unserem Unternehmen zusenden.',
          'zh-TW': 'Le enviaremos los resultados de la tasación en principio dentro de dos días hábiles después de la llegada a nuestra empresa.',
        },
        '査定結果へご同意から2営業日以内にお振込いたします。': {
          'en': 'We will transfer the money within two business days after agreeing to the assessment results.',
          'ko': 'Trasferiremo il denaro entro due giorni lavorativi dopo aver accettato i risultati della valutazione.',
          'zh': 'Wir werden das Geld innerhalb von zwei Werktagen nach Zustimmung zu den Bewertungsergebnissen überweisen.',
          'zh-TW': 'Transferiremos el dinero dentro de dos días hábiles después de aceptar los resultados de la evaluación.',
        },
        '可能です。1枚からでもご返送を承ります。\n着払いにてご返送をさせていただきます。': {
          'en': 'It is possible. We accept returns even for one item. We will arrange the return shipping at our expense.',
          'ko': 'È possibile. Accettiamo resi anche per un solo articolo. Organizzeremo la spedizione di ritorno a nostre spese.',
          'zh': 'Es ist möglich. Wir akzeptieren Rücksendungen auch für einen Artikel. Wir organisieren den Rückversand auf unsere Kosten.',
          'zh-TW': 'Es posible. Aceptamos devoluciones incluso por un solo artículo. Organizaremos el envío de devolución a nuestro cargo.',
        },
        '買取表に記載のカードのみとなります。\n予めご容赦くださいませ。': {
          'en': 'Only the cards listed on the purchase form are applicable. Please understand in advance.',
          'ko': 'Solo le carte elencate nel modulo d\'acquisto sono applicabili. Si prega di comprendere in anticipo.',
          'zh': 'Nur die auf dem Kaufformular aufgeführten Karten sind anwendbar. Bitte haben Sie im Voraus Verständnis.',
          'zh-TW': 'Solo las tarjetas enumeradas en el formulario de compra son aplicables. Por favor, comprenda de antemano.',
        },
        'はい。取得日より6ヶ月となります。': {
          'en': 'Yes. It will be six months from the date of acquisition.',
          'ko': 'Sì. Saranno sei mesi dalla data di acquisizione.',
          'zh': 'Ja. Es werden sechs Monate ab dem Erwerbsdatum sein.',
          'zh-TW': 'Sí. Serán seis meses a partir de la fecha de adquisición.',
        },
        '現金への換金はできません。': {
          'en': 'Cash redemption is not possible.',
          'ko': 'Il riscatto in contanti non è possibile.',
          'zh': 'Eine Barauszahlung ist nicht möglich.',
          'zh-TW': 'No es posible el canje en efectivo.',
        },
        '「商品名」の方が優先されます。ご心配をおかけしてしまい、大変申し訳ございません。': {
          'en': 'The "product name" will take precedence. We apologize for causing you concern.',
          'ko': 'Il "nome del prodotto" avrà la precedenza. Ci scusiamo per avervi causato preoccupazione.',
          'zh': 'Der "Produktname" hat Vorrang. Wir entschuldigen uns für die entstandenen Unannehmlichkeiten.',
          'zh-TW': 'El "nombre del producto" tendrá prioridad. Lamentamos haberle causado preocupación.',
        },
        '一度ご決定いただいたものは変更いたしかねます。予めご容赦くださいませ。': {
          'en': 'Once a decision has been made, it cannot be changed. Please understand in advance.',
          'ko': 'Una volta presa una decisione, non può essere cambiata. Si prega di comprendere in anticipo.',
          'zh': 'Sobald eine Entscheidung getroffen wurde, kann sie nicht mehr geändert werden. Bitte haben Sie im Voraus Verständnis.',
          'zh-TW': 'Una vez que se ha tomado una decisión, no se puede cambiar. Por favor, comprenda de antemano.',
        },
        '返金は原則不可となります。': {
          'en': 'Refunds are generally not possible.',
          'ko': 'I rimborsi generalmente non sono possibili.',
          'zh': 'Rückerstattungen sind in der Regel nicht möglich.',
          'zh-TW': 'Los reembolsos generalmente no son posibles.',
        },
        'ガチャで当たった景品を出品できたり、欲しいカードを購入できます。\n詳細はこちらをクリックしてください。': {
          'en': 'You can list the prizes you won in the gacha or purchase the cards you want. Please click here for details.',
          'ko': 'Puoi elencare i premi che hai vinto nel gacha o acquistare le carte che desideri. Clicca qui per i dettagli.',
          'zh': 'Sie können die Preise, die Sie im Gacha gewonnen haben, auflisten oder die Karten kaufen, die Sie möchten. Bitte klicken Sie hier für Details.',
          'zh-TW': 'Du kan lista de priser du vann i gacha eller köpa de kort du vill ha. Klicka här för detaljer.',
        },
        '日本のさまざまな法人さまの商品をガチャで購入することができるページです。': {
          'en': 'This is a page where you can purchase products from various Japanese corporations through a gacha system.',
          'ko': 'Questa è una pagina dove puoi acquistare prodotti da varie aziende giapponesi attraverso un sistema gacha.',
          'zh': 'Dies ist eine Seite, auf der Sie Produkte von verschiedenen japanischen Unternehmen über ein Gacha-System kaufen können.',
          'zh-TW': 'Detta är en sida där du kan köpa produkter från olika japanska företag genom ett gacha-system.',
        },
        'サイトについて': {
          'en': 'About the site',
          'ko': 'Informazioni sul sito',
          'zh': 'Über die Seite',
          'zh-TW': 'Om webbplatsen',
        },
        '発送について': {
          'en': 'About shipping',
          'ko': 'Informazioni sulla spedizione',
          'zh': 'Zum Versand',
          'zh-TW': 'Om frakt',
        },
        '商品について': {
          'en': 'About the product',
          'ko': 'Informazioni sul prodotto',
          'zh': 'Über das Produkt',
          'zh-TW': 'Om produkten',
        },
        'shopについて': {
          'en': 'About the shop',
          'ko': 'Informazioni sul negozio',
          'zh': 'Über den Laden',
          'zh-TW': 'Om butiken',
        },
        'X marketについて': {
          'en': 'About X market',
          'ko': 'Informazioni sul mercato X',
          'zh': 'Über den X-Markt',
          'zh-TW': 'Om X-marknaden',
        },
        'アカウントについて': {
          'en': 'About the account',
          'ko': 'Informazioni sull\'account',
          'zh': 'Über das Konto',
          'zh-TW': 'Om kontot',
        },
        '郵送買取について': {
          'en': 'About sell to us',
          'ko': 'Informazioni sulla vendita a noi',
          'zh': 'Über den Verkauf an uns',
          'zh-TW': 'Om att sälja till oss',
        },
        'コインについて': {
          'en': 'About the coin',
          'ko': 'Informazioni sulla moneta',
          'zh': 'Über die Münze',
          'zh-TW': 'Om myntet',
        },
        'キャンセル・返品・返金について': {
          'en': 'Regarding cancellation, returns, and refunds',
          'ko': 'Per quanto riguarda la cancellazione, i resi e i rimborsi',
          'zh': 'Bezüglich Stornierung, Rücksendungen und Rückerstattungen',
          'zh-TW': 'Angående avbokning, returer och återbetalningar',
        },
        '友達を紹介してコインを貰いたいけど、どうすればいいですか？': {
          'en': 'I want to introduce a friend and get coins, but what should I do?',
          'ko': 'Voglio presentare un amico e ottenere monete, ma cosa dovrei fare?',
          'zh': 'Ich möchte einen Freund vorstellen und Münzen bekommen, aber was soll ich tun?',
          'zh-TW': 'Jag vill presentera en vän och få mynt, men vad ska jag göra?',
        },
        '会員ランクを翌月も維持することはできますか？': {
          'en': 'Can I maintain my membership rank for the following month?',
          'ko': 'Posso mantenere il mio livello di appartenenza per il mese successivo?',
          'zh': 'Kann ich meinen Mitgliedsrang für den folgenden Monat beibehalten?',
          'zh-TW': 'Kan jag behålla min medlemskapsnivå för nästa månad?',
        },
        '私の会社の商材もガチャで販売できますか？': {
          'en': 'Can my company\'s products also be sold in the shop\'s gacha?',
          'ko': 'I prodotti della mia azienda possono essere venduti anche nel gacha del negozio?',
          'zh': 'Können die Produkte meines Unternehmens auch im Gacha des Ladens verkauft werden?',
          'zh-TW': 'Kan mitt företags produkter också säljas i butikens gacha?',
        },
        '問い合わせへの返信はどのくらいの時間で返ってきますか？': {
          'en': 'How long does it take to get a reply to an inquiry?',
          'ko': 'Quanto tempo ci vuole per ricevere una risposta a una richiesta?',
          'zh': 'Wie lange dauert es, eine Antwort auf eine Anfrage zu erhalten?',
          'zh-TW': 'Hur lång tid tar det att få svar på en förfrågan?',
        },
        '動画を見たのにコインが貰えなかった。なぜでしょうか？': {
          'en': 'I watched the video but didn\'t receive the coin. Why is that?',
          'ko': 'Ho guardato il video ma non ho ricevuto la moneta. Perché?',
          'zh': 'Ich habe das Video angesehen, aber die Münze nicht erhalten. Warum ist das so?',
          'zh-TW': 'Jag tittade på videon men fick inte myntet. Varför är det så?',
        },
        '発送はいつですか？': {
          'en': 'When is the shipment?',
          'ko': 'Quando è la spedizione?',
          'zh': 'Wann ist die Lieferung?',
          'zh-TW': 'När är leveransen?',
        },
        '梱包は丁寧ですか？': {
          'en': 'Is the packaging careful?',
          'ko': 'L\'imballaggio è accurato?',
          'zh': 'Ist die Verpackung sorgfältig?',
          'zh-TW': 'Är förpackningen noggrann?',
        },
        '配送業者はどこですか？': {
          'en': 'Where is the delivery company?',
          'ko': 'Dov\'è la compagnia di consegna?',
          'zh': 'Wo ist das Lieferunternehmen?',
          'zh-TW': 'Var är leveransföretaget?',
        },
        '送料はかかりますか？': {
          'en': 'Is there a shipping fee?',
          'ko': 'C\'è una tassa di spedizione?',
          'zh': 'Gibt es eine Versandgebühr?',
          'zh-TW': 'Är det en fraktavgift?',
        },
        '追跡番号はどこでわかりますか？': {
          'en': 'Where can I find the tracking number?',
          'ko': 'Dove posso trovare il numero di tracciamento?',
          'zh': 'Wo finde ich die Sendungsnummer?',
          'zh-TW': 'Var kan jag hitta spårningsnumret?',
        },
        '発送通知からどのくらいで追跡番号がインターネットで確認できますか？': {
          'en': 'How long after the shipping notification can the tracking number be checked online?',
          'ko': 'Quanto tempo dopo la notifica di spedizione si può controllare il numero di tracciamento online?',
          'zh': 'Wie lange nach der Versandbenachrichtigung kann die Sendungsnummer online überprüft werden?',
          'zh-TW': 'Hur lång tid efter leveransmeddelandet kan spårningsnumret kontrolleras online?',
        },
        '住所変更はどこからできますか？': {
          'en': 'Where can I change my address?',
          'ko': 'Dove posso cambiare il mio indirizzo?',
          'zh': 'Wo kann ich meine Adresse ändern?',
          'zh-TW': 'Var kan jag ändra min adress?',
        },
        'X marketで買った商品は何日くらいで届きますか？': {
          'en': 'How many days does it take for the products bought at X market to arrive?',
          'ko': 'Quanti giorni ci vogliono per l\'arrivo dei prodotti acquistati al mercato X?',
          'zh': 'Wie viele Tage dauert es, bis die im X-Markt gekauften Produkte ankommen?',
          'zh-TW': 'Hur många dagar tar det för produkterna köpta på X-marknaden att komma fram?',
        },
        'カードの状態は綺麗ですか？': {
          'en': 'Is the condition of the card good?',
          'ko': 'La condizione della carta è buona?',
          'zh': 'Ist der Zustand der Karte gut?',
          'zh-TW': 'Är kortets skick bra?',
        },
        '違う商品が届いた。どうすればいいですか？': {
          'en': 'A different product arrived. What should I do?',
          'ko': 'È arrivato un prodotto diverso. Cosa dovrei fare?',
          'zh': 'Ein anderes Produkt ist angekommen. Was soll ich tun?',
          'zh-TW': 'En annan produkt kom. Vad ska jag göra?',
        },
        '私たちの会社の商品を販売して欲しい。どうしたらいいですか？': {
          'en': 'I want our products to be sold as gacha on this site. What should I do?',
          'ko': 'Voglio che i nostri prodotti siano venduti come gacha su questo sito. Cosa dovrei fare?',
          'zh': 'Ich möchte, dass unsere Produkte als Gacha auf dieser Seite verkauft werden. Was soll ich tun?',
          'zh-TW': 'Jag vill att våra produkter ska säljas som gacha på den här sidan. Vad ska jag göra?',
        },
        'X marketに出品できないのはなぜですか？': {
          'en': 'Why can\'t I list it on X market?',
          'ko': 'Perché non posso elencarlo sul mercato X?',
          'zh': 'Warum kann ich es nicht auf dem X-Markt auflisten?',
          'zh-TW': 'Varför kan jag inte lista det på X-marknaden?',
        },
        'パスワードを忘れた。どうすればいいですか？': {
          'en': 'I forgot my password. What should I do?',
          'ko': 'Ho dimenticato la mia password. Cosa dovrei fare?',
          'zh': 'Ich habe mein Passwort vergessen. Was soll ich tun?',
          'zh-TW': 'Jag glömde mitt lösenord. Vad ska jag göra?',
        },
        '退会したい場合はどうすればいいですか？': {
          'en': 'What should I do if I want to withdraw?',
          'ko': 'Cosa dovrei fare se voglio ritirarmi?',
          'zh': 'Was soll ich tun, wenn ich mich zurückziehen möchte?',
          'zh-TW': 'Vad ska jag göra om jag vill dra mig tillbaka?',
        },
        '1人で複数のアカウントを所有することは可能ですか？': {
          'en': 'Is it possible to own multiple accounts by oneself?',
          'ko': 'È possibile possedere più account da soli?',
          'zh': 'Ist es möglich, mehrere Konten selbst zu besitzen?',
          'zh-TW': 'Är det möjligt att äga flera konton själv?',
        },
        '1アカウントを複数台の端末を利用することは可能ですか？': {
          'en': 'Is it possible to use one account on multiple devices?',
          'ko': 'È possibile utilizzare un account su più dispositivi?',
          'zh': 'Ist es möglich, ein Konto auf mehreren Geräten zu verwenden?',
          'zh-TW': 'Är det möjligt att använda ett konto på flera enheter?',
        },
        '何日くらいで査定結果がでますか？': {
          'en': 'How many days will it take to get the appraisal results?',
          'ko': 'Quanti giorni ci vorranno per ottenere i risultati della valutazione?',
          'zh': 'Wie viele Tage wird es dauern, bis die Bewertungsergebnisse vorliegen?',
          'zh-TW': 'Hur många dagar tar det att få utvärderingsresultaten?',
        },
        'いつ入金されますか？': {
          'en': 'When will the payment be made?',
          'ko': 'Quando verrà effettuato il pagamento?',
          'zh': 'Wann wird die Zahlung erfolgen?',
          'zh-TW': 'När kommer betalningen att göras?',
        },
        '返却は可能ですか？': {
          'en': 'Is a return possible?',
          'ko': 'È possibile un ritorno?',
          'zh': 'Ist eine Rückgabe möglich?',
          'zh-TW': 'Är en retur möjlig?',
        },
        '買取表に載っていないカードの買取は可能ですか？': {
          'en': 'Is it possible to buy cards that are not listed on the purchase list?',
          'ko': 'È possibile acquistare carte che non sono elencate nella lista degli acquisti?',
          'zh': 'Ist es möglich, Karten zu kaufen, die nicht auf der Einkaufsliste stehen?',
          'zh-TW': 'Är det möjligt att köpa kort som inte finns med på inköpslistan?',
        },
        '有効期限はありますか？': {
          'en': 'Is there an expiration date?',
          'ko': 'C\'è una data di scadenza?',
          'zh': 'Gibt es ein Ablaufdatum?',
          'zh-TW': 'Finns det ett utgångsdatum?',
        },
        '換金できますか？': {
          'en': 'Can it be exchanged for cash?',
          'ko': 'Può essere scambiato per contanti?',
          'zh': 'Kann es gegen Bargeld eingetauscht werden?',
          'zh-TW': 'Kan det bytas mot kontanter?',
        },
        'カードの画像と商品名が違うカードが当たった。どっちが正しいですか？': {
          'en': 'I received a card where the image and product name are different. Which one is correct?',
          'ko': 'Ho ricevuto una carta in cui l\'immagine e il nome del prodotto sono diversi. Quale è corretto?',
          'zh': 'Ich habe eine Karte erhalten, bei der Bild und Produktname unterschiedlich sind. Welches ist korrekt?',
          'zh-TW': 'Jag fick ett kort där bilden och produktnamnet är olika. Vilken är korrekt?',
        },
        '発送を希望している商品を誤ってコインに還元してしまった。変更できますか？': {
          'en': 'I accidentally converted the product I wanted to ship into coins. Can I change it?',
          'ko': 'Ho accidentalmente convertito il prodotto che volevo spedire in monete. Posso cambiarlo?',
          'zh': 'Ich habe versehentlich das Produkt, das ich versenden wollte, in Münzen umgewandelt. Kann ich es ändern?',
          'zh-TW': 'Jag råkade omvandla produkten jag ville skicka till mynt. Kan jag ändra det?',
        },
        '返金は可能でしょうか？': {
          'en': 'Is a refund possible?',
          'ko': 'È possibile un rimborso?',
          'zh': 'Ist eine Rückerstattung möglich?',
          'zh-TW': 'Är en återbetalning möjlig?',
        },
        'Xmarketとはなんですか？': {
          'en': 'What is Xmarket?',
          'ko': 'Cos\'è Xmarket?',
          'zh': 'Was ist Xmarket?',
          'zh-TW': 'Qué es Xmarket?',
        },
        'shopとはなんですか？': {
          'en': 'What is a shop?',
          'ko': 'Che cos\'è un negozio?',
          'zh': 'Was ist ein Geschäft?',
          'zh-TW': 'Qué es una tienda?',
        },
    },
  }),
  computed: {
    ...mapGetters({
      currentLanguage: 'user/currentLanguage',
    }),
  },
  methods: {
    t(code) {
      if (this.currentLanguage === 'jp') {
        return code;
      }
      if (this.i18n_message[code]) {
        if (this.i18n_message[code][this.currentLanguage]) {
          return this.i18n_message[code][this.currentLanguage];
        }
      }

      if (this.currentLanguage !== 'jp') {
        // console.log(`紐づけなし:${code}`);
      }
      return code;
    },
  },
};
